import React, { useEffect, useState, useLayoutEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from "./Components/Header";
import HomePage from "./Components/HomePage";
import LeftPart from "./Components/LeftPart";
import Login from "./Components/Login";
import Header_Login from "./Components/Header_Login";
import TagInfoModalManager from "./Components/AxisScada/widgets/TagInfoModalManager";
import axiosInstance from "./services/axiosConfig";

import Notifications from "./Components/Notifications";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//import  App2 from "./Flow/src/App";

import Page_Managment from "./Components/Page_Managment";
import All2Edit from "./Components/All2Edit";
import All3 from "./Components/All3";
import Electric_generator from "./Components/Electric_generator";
import Energy from "./Components/Energy";
import Energy2 from "./Components/Energy2";
import Energy3 from "./Components/Energy3";
import VRF1 from "./Components/VRF1";
import VRF2 from "./Components/VRF2";
import VRF3 from "./Components/VRF3";
import VRF4 from "./Components/VRF4";
import VRF5 from "./Components/VRF5";
import VRFKS from "./Components/VRFKlimaSantral";
import VRFHacim from "./Components/VRFHacim";

import VRFTeras from "./Components/VRFTeras";

import "firebase/database";
import Store from "./Store/Store";
import { connect } from "react-redux";
import {
  SET_COMPANY_ID,
  add_page,
  add_page_name,
  add_user_item,
  setCompaniesList,
  setProfilePhoto,
  setTesis,
  setTotalizerTags,
  set_alarms_action,
  set_booster_tags,
  set_cop,
  set_dashboard_data,
  set_email,
  set_energy_tags,
  set_energy_tags2,
  set_energy_tags3,
  set_fans_tags,
  set_group_id,
  set_group_item,
  set_hidrofor,
  set_main_path,
  set_misafir_oda,
  set_notis_action,
  set_pages,
  set_path,
  set_profile_infos,
  set_pumps_tags,
  set_reactflowList,
  set_sıcak_su_sistemi,
  set_tag_ids,
  set_tag_list,
  set_tag_values,
  set_tags_for_trend_page,
  set_uid,
  set_user_item,
  set_username,
  set_vrf2_tags,
  set_vrf3_tags,
  set_vrf4_tags,
  set_vrf5_tags,
  set_vrfks_tags,
  set_vrfhacim_tags,
  set_vrf_tags,
  set_vrf_teras_tags,
  set_water_storage,
  set_widget_library,
  set_yetkilendirme_state,
  set_fetch_pages_control,
  set_alarms_action2,
  set_ucer_id,
  set_temp_com_id,
  set_company_logo_url,
} from "./Action/Action";
import SignUpPage from "./Components/SignUpPage";
import PLC from "./Components/PLC";
import Channel from "./Components/Channel";
import Point from "./Components/Point";
import Profile from "./Components/Profile";
import Editprofile_ from "./Components/Editprofile_";
import Header3 from "./Components/Header3";
import Raporlama from "./Components/Raporlama";
import Alarm from "./Components/Alarm";
import Programflow from "./Components/Programflow";

// Flow Components
import WorkflowDashboard from "./Flow/WorkflowDashboard";
import CodeEditor from "./Flow/CodeEditor";
import TemplateManager from "./Flow/TemplateManager";
import ServiceManagement from "./Flow/ServiceManagement";
import DataSourcesLayout from "./Flow/components/datasources/DataSourcesLayout";
import DnDFlow from "./Flow/DnDFlow";

import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import Forgot_PWD from "./Components/Forgot_PWD";
import Dashboard from "./Components/Dashboard";
import Dashboard_vrf from "./Components/VRF/Dashboard_vrf";

import HotWaterBoiler from "./Components/HotWaterBoiler";
import Pumps from "./Components/Pumps";
import Booster from "./Components/Booster";
import Dash_Sicak_Su from "./Components/Sıcak_Su_Sistemi/Dash_Sicak_Su";
import Fans from "./Components/Fans";
import Main_Dash from "./Components/Main_Dash";
import Su_Depoları from "./Components/Su_Depoları";
import Dash_Pumps from "./Components/Pumps/Dash_Pumps";
import Hidrofor from "./Components/Hidrofor";
import Misafir_Oda from "./Components/Misafir-Oda/Misafir_Oda";
import Misafir_oda_izleme from "./Components/Misafir-Oda/Misafir_oda_izleme";
import User_Management from "./Components/User_Management";
import Role_Management from "./Components/Role_Management";

/// CROWN

import CrownHomePage from "./Components/CROWN/CHomePage";
import CDashboard from "./Components/CROWN/Dashboard/CDashboard";
import KazanDairesiHome from "./Components/CROWN/Kazan-Dairesi/KazanDairesiHome";
import CKazanSistemi from "./Components/CROWN/Kazan-Dairesi/KazanSistemi";
import Kazan1 from "./Components/CROWN/Kazan-Dairesi/Kazan-1";
import Kazan2 from "./Components/CROWN/Kazan-Dairesi/Kazan-2";
import Kazan3 from "./Components/CROWN/Kazan-Dairesi/Kazan-3";

import CSicakSuSistemi from "./Components/CROWN/Sicak-Su-Sistemi/SicakSuSistemi";

import CPompaVeHidrofor from "./Components/CROWN/Pompa-Hidrofor/PompaVeHidrofor";

import Pompalar1 from "./Components/CROWN/Pompa-Hidrofor/Pompalar1";
import Pompalar2 from "./Components/CROWN/Pompa-Hidrofor/Pompalar1";
import Pompalar3 from "./Components/CROWN/Pompa-Hidrofor/Pompalar1";

import CFanlar from "./Components/CROWN/Fanlar/Fanlar";
import EgzostFan from "./Components/CROWN/Fanlar/EgzostFan";

import CJeneratorHome from "./Components/CROWN/Jeneratör-Sistemi/JeneratorHome";

import CSuDepoları from "./Components/CROWN/Su-Depoları/SuDepoları";
import TesisSec from "./Components/TesisSec";
import ConnectionStatus from "./Components/ConnectionStatus";
import DynRead from "./DynRead";
import DynEdit from "./DynEdit";
import AddW_To_Library from "./AddW_To_Library";
import Template_Widget_Management from "./Components/Template_Widget_Management";
import Template_Widget_Edit from "./Components/Template_Widget_Edit";
import DeleteLogs from "./Components/TagLog/DeleteLogs";

// ✨ AxisScada Components
import PageDesignerRGL from "./Components/AxisScada/PageDesignerRGL";
import PageManagement from "./Components/AxisScada/PageManagement";
import WidgetManagement from "./Components/AxisScada/WidgetManagement";
import WidgetDesigner from "./Components/AxisScada/WidgetDesigner";
import PreviewMode from "./Components/AxisScada/PreviewMode";
import SCADARouter from "./Components/AxisScada/SCADARouter";
import TemplateWorkOrders from "./Components/AxisScada/TemplateWorkOrders";
import DenemeHomePage from "./Components/CROWN/Deneme/DenemeHomePage";

// WorkOrders Components
import WorkOrders from "./Components/WorkOrders";
import WorkOrderDetailsDialog from "./Components/WorkOrderDetailsDialog";
//import DnDFlow from "./Flow/src/DnDFlow";

// const app = new Realm.App({ id: "mongodb+srv://atesgokceoglu:<password>@cluster0.ylv4ntz.mongodb.net/" });

// MUI Theme Configuration
const theme = createTheme({
  palette: {
    primary: {
      main: '#edbc45',
    },
    background: {
      default: '#f8f4ff',
      paper: '#ffffff',
    },
  },
});

const App = (props) => {
  const history = useHistory();
  const location = useLocation();

  const [path, setPath] = useState("");
  const [company_id, Set_company_id] = useState("");

  const [sepwd, Setsepwd] = useState("");

  const [items, SetItems] = useState([]);

  let alfb = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];
  let say = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4,
    5,
  ];

  let su_depolari_state = [
    {
      "Kazan Dairesi Su Baskın İzlemesi ": [
        { text: "Alarm 1", tagId: "103", class: "su-baskin" },
        { text: "Alarm 2", tagId: "104", class: "su-baskin" },
      ],
    },
    {
      "DEPO 1": [{ text: "Depo_1", tagId: "62" }],
    },
  ];

  let state_2 = [
    {
      "LOBİ PANOSU": [
        { text: "TÜKETİM", tagId: "248" },
        { text: "GÜÇ", tagId: "243" },
        { text: "L1 GERİLİM", tagId: "228" },
        { text: "L2 GERİLİM", tagId: "236" },
        { text: "L3 GERİLİM", tagId: "237" },
        { text: "L1 AKIM", tagId: "238" },
        { text: "L2 AKIM", tagId: "239" },
        { text: "L3 AKIM", tagId: "240" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "242" },
        { text: "REAKTIF GÜÇ ", tagId: "244" },
        { text: "FREKANS", tagId: "246" },
      ],
    },
    {
      "YAKIT POMPASI": [
        { text: "TÜKETİM", tagId: "332" },
        { text: "GÜÇ", tagId: "327" },
        { text: "L1 GERİLİM", tagId: "312" },
        { text: "L2 GERİLİM", tagId: "320" },
        { text: "L3 GERİLİM", tagId: "321" },
        { text: "L1 AKIM", tagId: "322" },
        { text: "L2 AKIM", tagId: "323" },
        { text: "L3 AKIM", tagId: "324" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "326" },
        { text: "REAKTIF GÜÇ ", tagId: "328" },
        { text: "FREKANS", tagId: "330" },
      ],
    },
    {
      "YATAK KATLARI": [
        { text: "TÜKETİM", tagId: "353" },
        { text: "GÜÇ", tagId: "348" },
        { text: "L1 GERİLİM", tagId: "333" },
        { text: "L2 GERİLİM", tagId: "341" },
        { text: "L3 GERİLİM", tagId: "342" },
        { text: "L1 AKIM", tagId: "343" },
        { text: "L2 AKIM", tagId: "344" },
        { text: "L3 AKIM", tagId: "345" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "347" },
        { text: "REAKTIF GÜÇ ", tagId: "349" },
        { text: "FREKANS", tagId: "351" },
      ],
    },
    {
      "REZERVASYON OFİS": [
        { text: "TÜKETİM", tagId: "374" },
        { text: "GÜÇ", tagId: "369" },
        { text: "L1 GERİLİM", tagId: "354" },
        { text: "L2 GERİLİM", tagId: "362" },
        { text: "L3 GERİLİM", tagId: "363" },
        { text: "L1 AKIM", tagId: "364" },
        { text: "L2 AKIM", tagId: "365" },
        { text: "L3 AKIM", tagId: "366" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "368" },
        { text: "REAKTIF GÜÇ ", tagId: "370" },
        { text: "FREKANS", tagId: "372" },
      ],
    },
    {
      "CAFE SHAKESPEARE": [
        { text: "TÜKETİM", tagId: "395" },
        { text: "GÜÇ", tagId: "390" },
        { text: "L1 GERİLİM", tagId: "375" },
        { text: "L2 GERİLİM", tagId: "383" },
        { text: "L3 GERİLİM", tagId: "384" },
        { text: "L1 AKIM", tagId: "385" },
        { text: "L2 AKIM", tagId: "386" },
        { text: "L3 AKIM", tagId: "387" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "389" },
        { text: "REAKTIF GÜÇ ", tagId: "391" },
        { text: "FREKANS", tagId: "393" },
      ],
    },
    {
      FORFUN: [
        { text: "TÜKETİM", tagId: "416" },
        { text: "GÜÇ", tagId: "411" },
        { text: "L1 GERİLİM", tagId: "396" },
        { text: "L2 GERİLİM", tagId: "404" },
        { text: "L3 GERİLİM", tagId: "405" },
        { text: "L1 AKIM", tagId: "406" },
        { text: "L2 AKIM", tagId: "407" },
        { text: "L3 AKIM", tagId: "408" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "410" },
        { text: "REAKTIF GÜÇ ", tagId: "412" },
        { text: "FREKANS", tagId: "414" },
      ],
    },
    {
      "BAŞKA OL CAFE": [
        { text: "TÜKETİM", tagId: "437" },
        { text: "GÜÇ", tagId: "432" },
        { text: "L1 GERİLİM", tagId: "417" },
        { text: "L2 GERİLİM", tagId: "425" },
        { text: "L3 GERİLİM", tagId: "426" },
        { text: "L1 AKIM", tagId: "427" },
        { text: "L2 AKIM", tagId: "428" },
        { text: "L3 AKIM", tagId: "429" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "431" },
        { text: "REAKTIF GÜÇ ", tagId: "433" },
        { text: "FREKANS", tagId: "435" },
      ],
    },
  ];

  let state_3 = [
    {
      "KAZAN DAİRESİ": [
        { text: "TÜKETİM", tagId: "458" },
        { text: "GÜÇ", tagId: "453" },
        { text: "L1 GERİLİM", tagId: "438" },
        { text: "L2 GERİLİM", tagId: "446" },
        { text: "L3 GERİLİM", tagId: "447" },
        { text: "L1 AKIM", tagId: "448" },
        { text: "L2 AKIM", tagId: "449" },
        { text: "L3 AKIM", tagId: "450" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "452" },
        { text: "REAKTIF GÜÇ ", tagId: "454" },
        { text: "FREKANS", tagId: "456" },
      ],
    },
    {
      "GARAJ PANOSU": [
        { text: "TÜKETİM", tagId: "479" },
        { text: "GÜÇ", tagId: "474" },
        { text: "L1 GERİLİM", tagId: "459" },
        { text: "L2 GERİLİM", tagId: "467" },
        { text: "L3 GERİLİM", tagId: "468" },
        { text: "L1 AKIM", tagId: "469" },
        { text: "L2 AKIM", tagId: "470" },
        { text: "L3 AKIM", tagId: "471" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "473" },
        { text: "REAKTIF GÜÇ ", tagId: "475" },
        { text: "FREKANS", tagId: "477" },
      ],
    },
    {
      YEDEK: [
        { text: "TÜKETİM", tagId: "500" },
        { text: "GÜÇ", tagId: "495" },
        { text: "L1 GERİLİM", tagId: "480" },
        { text: "L2 GERİLİM", tagId: "488" },
        { text: "L3 GERİLİM", tagId: "489" },
        { text: "L1 AKIM", tagId: "490" },
        { text: "L2 AKIM", tagId: "491" },
        { text: "L3 AKIM", tagId: "492" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "494" },
        { text: "REAKTIF GÜÇ ", tagId: "496" },
        { text: "FREKANS", tagId: "498" },
      ],
    },
    {
      YEDEK: [
        { text: "TÜKETİM", tagId: "521" },
        { text: "GÜÇ", tagId: "516" },
        { text: "L1 GERİLİM", tagId: "501" },
        { text: "L2 GERİLİM", tagId: "509" },
        { text: "L3 GERİLİM", tagId: "510" },
        { text: "L1 AKIM", tagId: "511" },
        { text: "L2 AKIM", tagId: "512" },
        { text: "L3 AKIM", tagId: "513" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "515" },
        { text: "REAKTIF GÜÇ ", tagId: "517" },
        { text: "FREKANS", tagId: "519" },
      ],
    },
  ];

  let state_1 = [
    {
      KOMPANZASYON: [
        { text: "TÜKETİM", tagId: "557", class: "kompanzasyonClass" },
        { text: "TOPLAM AKTİF GÜÇ", tagId: "552", class: "kompanzasyonClass" },
        {
          text: "TOPLAM REAKTIF GÜÇ",
          tagId: "553",
          class: "kompanzasyonClass",
        },
        {
          text: "TOPLAM GÖRÜNÜR GÜÇ",
          tagId: "554",
          class: "kompanzasyonClass",
        },
        {
          text: "İNDÜKTİF REAKTİF ENERJİ",
          tagId: "555",
          class: "kompanzasyonClass",
        },
        {
          text: "KAPASİTİF REAKTİF ENERJİ",
          tagId: "556",
          class: "kompanzasyonClass",
        },
        { text: "L1 GERİLİM", tagId: "543", class: "kompanzasyonClass" },
        { text: "L2 GERİLİM", tagId: "550", class: "kompanzasyonClass" },
        { text: "L3 GERİLİM", tagId: "551", class: "kompanzasyonClass" },
        { text: "L1 AKIM", tagId: "547", class: "kompanzasyonClass" },
        { text: "L2 AKIM", tagId: "548", class: "kompanzasyonClass" },
        { text: "L3 AKIM", tagId: "549", class: "kompanzasyonClass" },
        { text: "TOPLAM COSFİ", tagId: "544", class: "kompanzasyonClass" },
        { text: "R FAZI COSFİ", tagId: "545", class: "kompanzasyonClass" },
        { text: "T FAZI COSFİ", tagId: "546", class: "kompanzasyonClass" },
        { text: "S FAZI COSFİ", tagId: "558", class: "kompanzasyonClass" },
      ],
    },
    {
      "ÇATI VRF BESLEME": [
        { text: "TÜKETİM", tagId: "185" },
        { text: "GÜÇ", tagId: "180" },
        { text: "L1 GERİLİM", tagId: "165" },
        { text: "L2 GERİLİM", tagId: "173" },
        { text: "L3 GERİLİM", tagId: "174" },
        { text: "L1 AKIM", tagId: "175" },
        { text: "L2 AKIM", tagId: "176" },
        { text: "L3 AKIM", tagId: "177" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "179" },
        { text: "REAKTIF GÜÇ ", tagId: "181" },
        { text: "FREKANS", tagId: "183" },
      ],
    },
    {
      "MERDİVEN VE KAT AYDINLATMA": [
        { text: "TÜKETİM", tagId: "206" },
        { text: "GÜÇ", tagId: "201" },
        { text: "L1 GERİLİM", tagId: "186" },
        { text: "L2 GERİLİM", tagId: "194" },
        { text: "L3 GERİLİM", tagId: "195" },
        { text: "L1 AKIM", tagId: "196" },
        { text: "L2 AKIM", tagId: "197" },
        { text: "L3 AKIM", tagId: "198" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "200" },
        { text: "REAKTIF GÜÇ ", tagId: "202" },
        { text: "FREKANS", tagId: "204" },
      ],
    },
    {
      "OTO YIKAMA": [
        { text: "TÜKETİM", tagId: "227" },
        { text: "GÜÇ", tagId: "222" },
        { text: "L1 GERİLİM", tagId: "207" },
        { text: "L2 GERİLİM", tagId: "215" },
        { text: "L3 GERİLİM", tagId: "216" },
        { text: "L1 AKIM", tagId: "217" },
        { text: "L2 AKIM", tagId: "218" },
        { text: "L3 AKIM", tagId: "219" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "221" },
        { text: "REAKTIF GÜÇ ", tagId: "223" },
        { text: "FREKANS", tagId: "225" },
      ],
    },

    {
      "ASANSÖR 1": [
        { text: "TÜKETİM", tagId: "311" },
        { text: "GÜÇ", tagId: "306" },
        { text: "L1 GERİLİM", tagId: "291" },
        { text: "L2 GERİLİM", tagId: "299" },
        { text: "L3 GERİLİM", tagId: "300" },
        { text: "L1 AKIM", tagId: "301" },
        { text: "L2 AKIM", tagId: "302" },
        { text: "L3 AKIM", tagId: "303" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "305" },
        { text: "REAKTIF GÜÇ ", tagId: "307" },
        { text: "FREKANS", tagId: "309" },
      ],
    },
    {
      "ASANSÖR 2": [
        { text: "TÜKETİM", tagId: "269" },
        { text: "GÜÇ", tagId: "264" },
        { text: "L1 GERİLİM", tagId: "249" },
        { text: "L2 GERİLİM", tagId: "257" },
        { text: "L3 GERİLİM", tagId: "258" },
        { text: "L1 AKIM", tagId: "259" },
        { text: "L2 AKIM", tagId: "260" },
        { text: "L3 AKIM", tagId: "261" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "263" },
        { text: "REAKTIF GÜÇ ", tagId: "265" },
        { text: "FREKANS", tagId: "267" },
      ],
    },
    {
      "ASANSÖR 3": [
        { text: "TÜKETİM", tagId: "290" },
        { text: "GÜÇ", tagId: "285" },
        { text: "L1 GERİLİM", tagId: "270" },
        { text: "L2 GERİLİM", tagId: "278" },
        { text: "L3 GERİLİM", tagId: "279" },
        { text: "L1 AKIM", tagId: "280" },
        { text: "L2 AKIM", tagId: "281" },
        { text: "L3 AKIM", tagId: "282" },
        { text: "GÜÇ FAKTÖRÜ", tagId: "284" },
        { text: "REAKTIF GÜÇ ", tagId: "286" },
        { text: "FREKANS", tagId: "288" },
      ],
    },
  ];

  let state_4 = [
    {
      "P1 Akım Değeri": [{ tagId: "60" }],
    },
    {
      "P2 Akım Değeri": [{ tagId: "61" }],
    },
    {
      "Boyler Gidiş Kollektörü": [{ tagId: "60" }],
    },
    {
      "Boyler Dönüş Kollektörü": [{ tagId: "61" }],
    },

    {
      "Isıtma Gidiş Kollektörü": [{ tagId: "5054" }],
    },
    {
      "Isıtma Dönüş Kollektörü": [{ tagId: "5054" }],
    },
    { "Giriş Su Sıcaklığı(°C)": [{ tagId: "5008" }] },
    { "Çıkış Su Sıcaklığı(°C)": [{ tagId: "5007" }] },

    { "Anlık Debi(m³/h)": [{ tagId: "5010" }] },

    { "Toplam Geçen Su(m³)": [{ tagId: "5023" }] },

    { "Toplam Tüketim(kWh) ": [{ tagId: "8700" }] },
  ];

  let pumps_state = [
    {
      "ESANJÖR POMPA GRUBU DURUM İZLEMESİ ": [
        { text: "P1 Çalışma Durumu", tagId: "105" },
        { text: "P1 Arıza Durumu", tagId: "106" },
        { text: "P2 Çalışma Durumu", tagId: "123" },
        { text: "P2 Arıza Durumu", tagId: "124" },
        { text: "P1 Tüketim(kWh)", tagId: "5006", class: "pumps-kwh" },
        { text: "P2 Tüketim(kWh)", tagId: "5021", class: "pumps-kwh" },
        { text: "P1 Akım", tagId: "64", class: "pumps-p1-p2" },
        { text: "", tagId: "65" },
        { text: "", tagId: "66" },
        { text: "P2 Akım", tagId: "67", class: "pumps-p1-p2" },
        { text: "", tagId: "68" },
        { text: "", tagId: "69" },
      ],
    },
    {
      "KULLANMA SUYU POMPA GRUBU DURUM İZLEMESİ ": [
        { text: "P1 Çalışma Durumu", tagId: "107" },
        { text: "P1 Arıza Durumu", tagId: "108" },
        { text: "P2 Çalışma Durumu", tagId: "109" },
        { text: "P2 Arıza Durumu", tagId: "110" },
        { text: "P1 Tüketim(kWh)", tagId: "5013", class: "pumps-kwh" },
        { text: "P2 Tüketim(kWh)", tagId: "5014", class: "pumps-kwh" },
        { text: "P1 Akım", tagId: "91", class: "pumps-p1-p2" },
        { text: "", tagId: "92" },
        { text: "", tagId: "93" },
        { text: "P2 Akım", tagId: "88", class: "pumps-p1-p2" },
        { text: "", tagId: "89" },
        { text: "", tagId: "90" },
      ],
    },
    {
      "BOYLER SİRKÜLASYON POMPA GRUBU DURUM İZLEMESİ ": [
        { text: "P1 Çalışma Durumu", tagId: "111" },
        { text: "P1 Arıza Durumu", tagId: "112" },
        { text: "P2 Çalışma Durumu", tagId: "113" },
        { text: "P2 Arıza Durumu", tagId: "114" },
        { text: "P1 Tüketim(kWh)", tagId: "5015", class: "pumps-kwh" },
        { text: "P2 Tüketim(kWh)", tagId: "5016", class: "pumps-kwh" },
        { text: "P1 Akım", tagId: "85", class: "pumps-p1-p2" },
        { text: "", tagId: "86" },
        { text: "", tagId: "87" },

        { text: "P2 Akım", tagId: "82", class: "pumps-p1-p2" },
        { text: "", tagId: "83" },
        { text: "", tagId: "84" },
      ],
    },
    {
      "ISI POMPASI POMPA GRUBU DURUM İZLEMESİ ": [
        { text: "P1 Çalışma Durumu", tagId: "115" },
        { text: "P1 Arıza Durumu", tagId: "116" },
        { text: "P2 Çalışma Durumu", tagId: "117" },
        { text: "P2 Arıza Durumu", tagId: "118" },
        { text: "P1 Tüketim(kWh)", tagId: "5017", class: "pumps-kwh" },
        { text: "P2 Tüketim(kWh)", tagId: "5018", class: "pumps-kwh" },
        { text: "P1 Akım", tagId: "79", class: "pumps-p1-p2" },
        { text: "", tagId: "80" },
        { text: "", tagId: "81" },

        { text: "P2 Akım", tagId: "76", class: "pumps-p1-p2" },
        { text: "", tagId: "77" },
        { text: "", tagId: "78" },
      ],
    },
    {
      "BOOSTER POMPA GRUBU DURUM İZLEMESİ ": [
        { text: "P1 Çalışma Durumu", tagId: "119" },
        { text: "P1 Arıza Durumu", tagId: "120" },
        { text: "P2 Çalışma Durumu", tagId: "121" },
        { text: "P2 Arıza Durumu", tagId: "122" },
        { text: "P1 Tüketim(kWh)", tagId: "5019", class: "pumps-kwh" },
        { text: "P2 Tüketim(kWh)", tagId: "5020", class: "pumps-kwh" },
        { text: "P1 Akım", tagId: "73", class: "pumps-p1-p2" },
        { text: "", tagId: "74" },
        { text: "", tagId: "75" },
        { text: "P2 Akım", tagId: "70", class: "pumps-p1-p2" },
        { text: "", tagId: "71" },
        { text: "", tagId: "72" },
      ],
    },
    {
      "ELEKTRİK YANGIN POMPA GRUBU DURUM İZLEMESİ ": [
        { text: "Çalışma Durumu", tagId: "125" },
        { text: "Arıza Durumu", tagId: "126" },
      ],
    },
    {
      "ATIK SU POMPA GRUBU DURUM İZLEMESİ ": [
        { text: "P1 Çalışma Durumu", tagId: "129" },
        { text: "P1 Arıza Durumu", tagId: "130" },
        { text: "P2 Çalışma Durumu", tagId: "131" },
        { text: "P2 Arıza Durumu", tagId: "132" },
      ],
    },
  ];

  let hidrofor_state = [
    {
      "Hidrofor Pompası 1": [
        { text: "L1 Akım", tagId: "94" },
        { text: "L2 Akım", tagId: "95" },
        { text: "L3 Akım", tagId: "96" },
        { text: "Hidrofor Tüketim(kWh)", tagId: "5022", class: "hidro-pump" },
      ],
    },
    {
      "Hidrofor Pompası 2": [
        { text: "L1 Akım", tagId: "100" },
        { text: "L2 Akım", tagId: "101" },
        { text: "L3 Akım", tagId: "102" },
      ],
    },
    {
      "Hidrofor Pompası 3": [
        { text: "L1 Akım", tagId: "97" },
        { text: "L2 Akım", tagId: "98" },
        { text: "L3 Akım", tagId: "99" },
      ],
    },
  ];
  let vrf_state = [
    {
      101: [
        { text: "Oda Sıcaklığı", tagId: "971" },
        { text: "Oda Set Değeri", tagId: "1105", device: "9223" },
        { text: "Cihaz", tagId: "1333", tagId2: "1455", device: "9221" },
        { text: "Çalışma Modu", tagId: "2694", tagId2: "2851", device: "9220" },
        { text: "Çalışma Durumu", tagId: "2694", tagId2: "2851" },

        { text: "Fan Modu", tagId: "8149", tagId2: "2852" },
        { text: "Soğutma Modu Set Değeri", tagId: "1106" },
        { text: "Isıtma Modu Set Değeri", tagId: "1107" },
        { text: "Filtre Durumu", tagId: "1335" },
        { text: "Filtre Reset", tagId: "1605" },
        { text: "Arıza Durumu", tagId: "7228" },
        { text: "Arıza Kodu", tagId: "2693" },
      ],
    },
    {
      102: [
        { text: "Oda Sıcaklığı", tagId: "970" },
        { text: "Oda Set Değeri", tagId: "1099", device: "9218" },
        { text: "Cihaz", tagId: "1329", tagId2: "1454", device: "9215" },
        { text: "Çalışma Modu", tagId: "2690", tagId2: "2848", device: "9216" },
        { text: "Çalışma Durumu", tagId: "2690", tagId2: "2848" },
        { text: "Fan Modu", tagId: "8145", tagId2: "2849" },
        { text: "Soğutma Modu Set Değeri", tagId: "1100" },
        { text: "Isıtma Modu Set Değeri", tagId: "1101" },
        { text: "Filtre Durumu", tagId: "1331" },
        { text: "Filtre Reset", tagId: "1598" },
        { text: "Arıza Durumu", tagId: "7225" },
        { text: "Arıza Kodu", tagId: "2689" },
      ],
    },
    {
      103: [
        { text: "Oda Sıcaklığı", tagId: "969" },
        { text: "Oda Set Değeri", tagId: "1093", device: "9213" },
        { text: "Cihaz", tagId: "1325", tagId2: "1453", device: "9210" },
        { text: "Çalışma Modu", tagId: "2686", tagId2: "2845", device: "9211" },
        { text: "Çalışma Durumu", tagId: "2686", tagId2: "2845" },

        { text: "Fan Modu", tagId: "8141", tagId2: "2846" },
        { text: "Soğutma Modu Set Değeri", tagId: "1094" },
        { text: "Isıtma Modu Set Değeri", tagId: "1095" },
        { text: "Filtre Durumu", tagId: "1327" },
        { text: "Filtre Reset", tagId: "1591" },
        { text: "Arıza Durumu", tagId: "7222" },
        { text: "Arıza Kodu", tagId: "2685" },
      ],
    },
    {
      104: [
        { text: "Oda Sıcaklığı", tagId: "968" },
        { text: "Oda Set Değeri", tagId: "1087", device: "9208" },
        { text: "Cihaz", tagId: "1321", tagId2: "1452", device: "9205" },
        { text: "Çalışma Modu", tagId: "2722", tagId2: "2842", device: "9206" },
        { text: "Çalışma Durumu", tagId: "2722", tagId2: "2842" },

        { text: "Fan Modu", tagId: "8137", tagId2: "2842" },
        { text: "Soğutma Modu Set Değeri", tagId: "1088" },
        { text: "Isıtma Modu Set Değeri", tagId: "1089" },
        { text: "Filtre Durumu", tagId: "1323" },
        { text: "Filtre Reset", tagId: "1585" },
        { text: "Arıza Durumu", tagId: "7219" },
        { text: "Arıza Kodu", tagId: "2681" },
      ],
    },
    {
      105: [
        { text: "Oda Sıcaklığı", tagId: "967" },
        { text: "Oda Set Değeri", tagId: "1081", device: "9203" },
        { text: "Cihaz", tagId: "1317", tagId2: "1451", device: "9200" },
        { text: "Çalışma Modu", tagId: "2678", tagId2: "2839", device: "9201" },
        { text: "Çalışma Durumu", tagId: "2678", tagId2: "2839" },

        { text: "Fan Modu", tagId: "8133", tagId2: "2840" },
        { text: "Soğutma Modu Set Değeri", tagId: "1082" },
        { text: "Isıtma Modu Set Değeri", tagId: "1083" },
        { text: "Filtre Durumu", tagId: "1319" },
        { text: "Filtre Reset", tagId: "1578" },
        { text: "Arıza Durumu", tagId: "7216" },
        { text: "Arıza Kodu", tagId: "2677" },
      ],
    },
    {
      106: [
        { text: "Oda Sıcaklığı", tagId: "966" },
        { text: "Oda Set Değeri", tagId: "1075", device: "9198" },
        { text: "Cihaz", tagId: "1313", tagId2: "1450", device: "9195" },
        { text: "Çalışma Modu", tagId: "2674", tagId2: "2836", device: "9196" },
        { text: "Çalışma Durumu", tagId: "2674", tagId2: "2836" },

        { text: "Fan Modu", tagId: "8129", tagId2: "2837" },
        { text: "Soğutma Modu Set Değeri", tagId: "1076" },
        { text: "Isıtma Modu Set Değeri", tagId: "1077" },
        { text: "Filtre Durumu", tagId: "1315" },
        { text: "Filtre Reset", tagId: "1571" },
        { text: "Arıza Durumu", tagId: "7213" },
        { text: "Arıza Kodu", tagId: "2673" },
      ],
    },
    {
      107: [
        { text: "Oda Sıcaklığı", tagId: "965" },
        { text: "Oda Set Değeri", tagId: "1069", device: "9193" },
        { text: "Cihaz", tagId: "1309", tagId2: "1449", device: "9190" },
        { text: "Çalışma Modu", tagId: "2670", tagId2: "2833", device: "9191" },
        { text: "Çalışma Durumu", tagId: "2670", tagId2: "2833" },

        { text: "Fan Modu", tagId: "8125", tagId2: "2834" },
        { text: "Soğutma Modu Set Değeri", tagId: "1070" },
        { text: "Isıtma Modu Set Değeri", tagId: "1071" },
        { text: "Filtre Durumu", tagId: "1311" },
        { text: "Filtre Reset", tagId: "1564" },
        { text: "Arıza Durumu", tagId: "7210" },
        { text: "Arıza Kodu", tagId: "2669" },
      ],
    },
    {
      108: [
        { text: "Oda Sıcaklığı", tagId: "964" },
        { text: "Oda Set Değeri", tagId: "1063", device: "9188" },
        { text: "Cihaz", tagId: "1305", tagId2: "1448", device: "9185" },
        { text: "Çalışma Modu", tagId: "2666", tagId2: "2830", device: "9186" },
        { text: "Çalışma Durumu", tagId: "2666", tagId2: "2830" },

        { text: "Fan Modu", tagId: "8121", tagId2: "2831" },
        { text: "Soğutma Modu Set Değeri", tagId: "1064" },
        { text: "Isıtma Modu Set Değeri", tagId: "1065" },
        { text: "Filtre Durumu", tagId: "1307" },
        { text: "Filtre Reset", tagId: "1557" },
        { text: "Arıza Durumu", tagId: "7207" },
        { text: "Arıza Kodu", tagId: "2665" },
      ],
    },
    {
      109: [
        { text: "Oda Sıcaklığı", tagId: "963" },
        { text: "Oda Set Değeri", tagId: "1057", device: "9183" },
        { text: "Cihaz", tagId: "1301", tagId2: "1447", device: "9181" },
        { text: "Çalışma Modu", tagId: "2662", tagId2: "2827", device: "9180" },
        { text: "Çalışma Durumu", tagId: "2662", tagId2: "2827" },

        { text: "Fan Modu", tagId: "8117", tagId2: "2828" },
        { text: "Soğutma Modu Set Değeri", tagId: "1058" },
        { text: "Isıtma Modu Set Değeri", tagId: "1059" },
        { text: "Filtre Durumu", tagId: "1303" },
        { text: "Filtre Reset", tagId: "1550" },
        { text: "Arıza Durumu", tagId: "7204" },
        { text: "Arıza Kodu", tagId: "2661" },
      ],
    },
    {
      110: [
        { text: "Oda Sıcaklığı", tagId: "962" },
        { text: "Oda Set Değeri", tagId: "1051", device: "9178" },
        { text: "Cihaz", tagId: "1297", tagId2: "1446", device: "9175" },
        { text: "Çalışma Modu", tagId: "2658", tagId2: "2824", device: "9176" },
        { text: "Çalışma Durumu", tagId: "2658", tagId2: "2824" },

        { text: "Fan Modu", tagId: "8113", tagId2: "2825" },
        { text: "Soğutma Modu Set Değeri", tagId: "1052" },
        { text: "Isıtma Modu Set Değeri", tagId: "1053" },
        { text: "Filtre Durumu", tagId: "1299" },
        { text: "Filtre Reset", tagId: "1543" },
        { text: "Arıza Durumu", tagId: "7201" },
        { text: "Arıza Kodu", tagId: "2657" },
      ],
    },
    {
      111: [
        { text: "Oda Sıcaklığı", tagId: "961" },
        { text: "Oda Set Değeri", tagId: "1045", device: "9173" },
        { text: "Cihaz", tagId: "1293", tagId2: "1445", device: "9170" },
        { text: "Çalışma Modu", tagId: "2654", tagId2: "2821", device: "9171" },
        { text: "Çalışma Durumu", tagId: "2654", tagId2: "2821" },

        { text: "Fan Modu", tagId: "8109", tagId2: "2822" },
        { text: "Soğutma Modu Set Değeri", tagId: "1046" },
        { text: "Isıtma Modu Set Değeri", tagId: "1047" },
        { text: "Filtre Durumu", tagId: "1295" },
        { text: "Filtre Reset", tagId: "1536" },
        { text: "Arıza Durumu", tagId: "7198" },
        { text: "Arıza Kodu", tagId: "2653" },
      ],
    },
    {
      112: [
        { text: "Oda Sıcaklığı", tagId: "960" },
        { text: "Oda Set Değeri", tagId: "1039", device: "9168" },
        { text: "Cihaz", tagId: "1289", tagId2: "1444", device: "9165" },
        { text: "Çalışma Modu", tagId: "2650", tagId2: "2818", device: "9166" },
        { text: "Çalışma Durumu", tagId: "2650", tagId2: "2818" },

        { text: "Fan Modu", tagId: "8105", tagId2: "2819" },
        { text: "Soğutma Modu Set Değeri", tagId: "1040" },
        { text: "Isıtma Modu Set Değeri", tagId: "1041" },
        { text: "Filtre Durumu", tagId: "1291" },
        { text: "Filtre Reset", tagId: "1529" },
        { text: "Arıza Durumu", tagId: "7195" },
        { text: "Arıza Kodu", tagId: "2649" },
      ],
    },
    {
      114: [
        { text: "Oda Sıcaklığı", tagId: "959" },
        { text: "Oda Set Değeri", tagId: "1033", device: "9163" },
        { text: "Cihaz", tagId: "1285", tagId2: "1443", device: "9160" },
        { text: "Çalışma Modu", tagId: "2646", tagId2: "2815", device: "9161" },
        { text: "Çalışma Durumu", tagId: "2646", tagId2: "2815" },

        { text: "Fan Modu", tagId: "8101", tagId2: "2816" },
        { text: "Soğutma Modu Set Değeri", tagId: "1034" },
        { text: "Isıtma Modu Set Değeri", tagId: "1035" },
        { text: "Filtre Durumu", tagId: "1287" },
        { text: "Filtre Reset", tagId: "1522" },
        { text: "Arıza Durumu", tagId: "7192" },
        { text: "Arıza Kodu", tagId: "2645" },
      ],
    },
    {
      115: [
        { text: "Oda Sıcaklığı", tagId: "958" },
        { text: "Oda Set Değeri", tagId: "1027", device: "9158" },
        { text: "Cihaz", tagId: "1281", tagId2: "1442", device: "9155" },
        { text: "Çalışma Modu", tagId: "2642", tagId2: "2812", device: "9156" },
        { text: "Çalışma Durumu", tagId: "2642", tagId2: "2812" },

        { text: "Fan Modu", tagId: "8097", tagId2: "2813" },
        { text: "Soğutma Modu Set Değeri", tagId: "1028" },
        { text: "Isıtma Modu Set Değeri", tagId: "1029" },
        { text: "Filtre Durumu", tagId: "1283" },
        { text: "Filtre Reset", tagId: "1515" },
        { text: "Arıza Durumu", tagId: "7189" },
        { text: "Arıza Kodu", tagId: "2641" },
      ],
    },
    {
      116: [
        { text: "Oda Sıcaklığı", tagId: "957" },
        { text: "Oda Set Değeri", tagId: "1021", device: "9153" },
        { text: "Cihaz", tagId: "1277", tagId2: "1441", device: "9150" },
        { text: "Çalışma Modu", tagId: "2638", tagId2: "2809", device: "9151" },
        { text: "Çalışma Durumu", tagId: "2638", tagId2: "2809" },

        { text: "Fan Modu", tagId: "8093", tagId2: "2810" },
        { text: "Soğutma Modu Set Değeri", tagId: "1022" },
        { text: "Isıtma Modu Set Değeri", tagId: "1023" },
        { text: "Filtre Durumu", tagId: "1279" },
        { text: "Filtre Reset", tagId: "1508" },
        { text: "Arıza Durumu", tagId: "7186" },
        { text: "Arıza Kodu", tagId: "2637" },
      ],
    },
    {
      117: [
        { text: "Oda Sıcaklığı", tagId: "956" },
        { text: "Oda Set Değeri", tagId: "1015", device: "9148" },
        { text: "Cihaz", tagId: "1273", tagId2: "1440", device: "9145" },
        { text: "Çalışma Modu", tagId: "2634", tagId2: "2806", device: "9146" },
        { text: "Çalışma Durumu", tagId: "2634", tagId2: "2806" },

        { text: "Fan Modu", tagId: "8089", tagId2: "2807" },
        { text: "Soğutma Modu Set Değeri", tagId: "1016" },
        { text: "Isıtma Modu Set Değeri", tagId: "1017" },
        { text: "Filtre Durumu", tagId: "1275" },
        { text: "Filtre Reset", tagId: "1501" },
        { text: "Arıza Durumu", tagId: "7183" },
        { text: "Arıza Kodu", tagId: "2633" },
      ],
    },
    {
      118: [
        { text: "Oda Sıcaklığı", tagId: "955" },
        { text: "Oda Set Değeri", tagId: "1009", device: "9143" },
        { text: "Cihaz", tagId: "1269", tagId2: "1439", device: "9140" },
        { text: "Çalışma Modu", tagId: "2630", tagId2: "2803", device: "9141" },
        { text: "Çalışma Durumu", tagId: "2630", tagId2: "2803" },

        { text: "Fan Modu", tagId: "8085", tagId2: "2804" },
        { text: "Soğutma Modu Set Değeri", tagId: "1010" },
        { text: "Isıtma Modu Set Değeri", tagId: "1011" },
        { text: "Filtre Durumu", tagId: "1271" },
        { text: "Filtre Reset", tagId: "1494" },
        { text: "Arıza Durumu", tagId: "7180" },
        { text: "Arıza Kodu", tagId: "2629" },
      ],
    },
    {
      119: [
        { text: "Oda Sıcaklığı", tagId: "954" },
        { text: "Oda Set Değeri", tagId: "1003", device: "9138" },
        { text: "Cihaz", tagId: "1265", tagId2: "1438", device: "9135" },
        { text: "Çalışma Modu", tagId: "2626", tagId2: "2800", device: "9136" },
        { text: "Çalışma Durumu", tagId: "2626", tagId2: "2800" },

        { text: "Fan Modu", tagId: "8081", tagId2: "2801" },
        { text: "Soğutma Modu Set Değeri", tagId: "1004" },
        { text: "Isıtma Modu Set Değeri", tagId: "1005" },
        { text: "Filtre Durumu", tagId: "1267" },
        { text: "Filtre Reset", tagId: "1487" },
        { text: "Arıza Durumu", tagId: "7177" },
        { text: "Arıza Kodu", tagId: "2625" },
      ],
    },
  ];

  let vrf5_state = [
    {
      501: [
        { text: "Oda Sıcaklığı", tagId: "5032" },
        { text: "Oda Set Değeri", tagId: "5106", device: "9877" },
        { text: "Cihaz", tagId: "5358", tagId2: "5516", device: "9874" },
        { text: "Çalışma Modu", tagId: "6639", tagId2: "6808", device: "9875" },
        { text: "Çalışma Durumu", tagId: "6639" },
        { text: "Fan Modu", tagId: "6640", tagId2: "6809" },
        { text: "Soğutma Modu Set Değeri", tagId: "5107" },
        { text: "Isıtma Modu Set Değeri", tagId: "5108" },
        { text: "Filtre Durumu", tagId: "5360" },
        { text: "Filtre Reset", tagId: "5590" },
        { text: "Arıza Durumu", tagId: "8551" },
        { text: "Arıza Kodu", tagId: "6638" },
      ],
    },
    {
      502: [
        { text: "Oda Sıcaklığı", tagId: "5031" },
        { text: "Oda Set Değeri", tagId: "5100", device: "9871" },
        { text: "Cihaz", tagId: "5354", tagId2: "5515", device: "9868" },
        { text: "Çalışma Modu", tagId: "6635", tagId2: "6805", device: "9869" },
        { text: "Çalışma Durumu", tagId: "6635" },

        { text: "Fan Modu", tagId: "6636", tagId2: "6806" },
        { text: "Soğutma Modu Set Değeri", tagId: "5101" },
        { text: "Isıtma Modu Set Değeri", tagId: "5102" },
        { text: "Filtre Durumu", tagId: "5356" },
        { text: "Filtre Reset", tagId: "5584" },
        { text: "Arıza Durumu", tagId: "8547" },
        { text: "Arıza Kodu", tagId: "6634" },
      ],
    },
    {
      503: [
        { text: "Oda Sıcaklığı", tagId: "5030" },
        { text: "Oda Set Değeri", tagId: "5094", device: "9865" },
        { text: "Cihaz", tagId: "5350", tagId2: "5514", device: "9862" },
        { text: "Çalışma Modu", tagId: "6631", tagId2: "6802", device: "9863" },
        { text: "Çalışma Durumu", tagId: "6631" },

        { text: "Fan Modu", tagId: "6632", tagId2: "6803" },
        { text: "Soğutma Modu Set Değeri", tagId: "5095" },
        { text: "Isıtma Modu Set Değeri", tagId: "5096" },
        { text: "Filtre Durumu", tagId: "5352" },
        { text: "Filtre Reset", tagId: "5578" },
        { text: "Arıza Durumu", tagId: "8543" },
        { text: "Arıza Kodu", tagId: "6630" },
      ],
    },
    {
      504: [
        { text: "Oda Sıcaklığı", tagId: "5029" },
        { text: "Oda Set Değeri", tagId: "5088", device: "9859" },
        { text: "Cihaz", tagId: "5346", tagId2: "5513", device: "9856" },
        { text: "Çalışma Modu", tagId: "6627", tagId2: "6799", device: "9857" },
        { text: "Çalışma Durumu", tagId: "6627" },

        { text: "Fan Modu", tagId: "6628", tagId2: "6800" },
        { text: "Soğutma Modu Set Değeri", tagId: "5089" },
        { text: "Isıtma Modu Set Değeri", tagId: "5090" },
        { text: "Filtre Durumu", tagId: "5348" },
        { text: "Filtre Reset", tagId: "5572" },
        { text: "Arıza Durumu", tagId: "8539" },
        { text: "Arıza Kodu", tagId: "6626" },
      ],
    },
    {
      505: [
        { text: "Oda Sıcaklığı", tagId: "5028" },
        { text: "Oda Set Değeri", tagId: "5082", device: "9853" },
        { text: "Cihaz", tagId: "5342", tagId2: "5512", device: "9850" },
        { text: "Çalışma Modu", tagId: "6623", tagId2: "6796", device: "9851" },
        { text: "Çalışma Durumu", tagId: "6623" },

        { text: "Fan Modu", tagId: "6624", tagId2: "6797" },
        { text: "Soğutma Modu Set Değeri", tagId: "5083" },
        { text: "Isıtma Modu Set Değeri", tagId: "5084" },
        { text: "Filtre Durumu", tagId: "5344" },
        { text: "Filtre Reset", tagId: "5566" },
        { text: "Arıza Durumu", tagId: "8535" },
        { text: "Arıza Kodu", tagId: "6622" },
      ],
    },
    {
      506: [
        { text: "Oda Sıcaklığı", tagId: "5027" },
        { text: "Oda Set Değeri", tagId: "5076", device: "9847" },
        { text: "Cihaz", tagId: "5338", tagId2: "5511", device: "9844" },
        { text: "Çalışma Modu", tagId: "6619", tagId2: "6793", device: "9845" },
        { text: "Çalışma Durumu", tagId: "6619" },

        { text: "Fan Modu", tagId: "6620", tagId2: "6794" },
        { text: "Soğutma Modu Set Değeri", tagId: "5077" },
        { text: "Isıtma Modu Set Değeri", tagId: "5078" },
        { text: "Filtre Durumu", tagId: "5340" },
        { text: "Filtre Reset", tagId: "5560" },
        { text: "Arıza Durumu", tagId: "8531" },
        { text: "Arıza Kodu", tagId: "6618" },
      ],
    },
  ];

  let vrfks_state = [
    {
      701: [
        { text: "Oda Sıcaklığı", tagId: "8701" },
        { text: "Oda Set Değeri", tagId: "8703" },
        { text: "Cihaz", tagId: "8711", tagId2: "8709" },
        { text: "Çalışma Modu", tagId: "8717", tagId2: "8723" },
        { text: "Çalışma Durumu", tagId: "8717" },
        { text: "Fan Modu", tagId: "8727", tagId2: "8724" },
        { text: "Soğutma Modu Set Değeri", tagId: "5107" },
        { text: "Isıtma Modu Set Değeri", tagId: "5108" },
        { text: "Filtre Durumu", tagId: "8712" },
        { text: "Filtre Reset", tagId: "8721" },
        { text: "Arıza Durumu", tagId: "8715" },
        { text: "Arıza Kodu", tagId: "8718" },
      ],
    },
    {
      702: [
        { text: "Oda Sıcaklığı", tagId: "8702" },
        { text: "Oda Set Değeri", tagId: "8706" },
        { text: "Cihaz", tagId: "8713", tagId2: "8710" },
        { text: "Çalışma Modu", tagId: "8719", tagId2: "8725" },
        { text: "Çalışma Durumu", tagId: "8719" },

        { text: "Fan Modu", tagId: "8728", tagId2: "8726" },
        { text: "Soğutma Modu Set Değeri", tagId: "5101" },
        { text: "Isıtma Modu Set Değeri", tagId: "5102" },
        { text: "Filtre Durumu", tagId: "8714" },
        { text: "Filtre Reset", tagId: "8722" },
        { text: "Arıza Durumu", tagId: "8716" },
        { text: "Arıza Kodu", tagId: "8720" },
      ],
    },
  ];

  let vrfhacim_state = [
    {
      // LOBİ
      801: [
        { text: "Oda Sıcaklığı", tagId: "973" },
        { text: "Oda Set Değeri", tagId: "1117", device: "9233" },
        { text: "Cihaz", tagId: "1341", tagId2: "1457", device: "9230" },
        { text: "Çalışma Modu", tagId: "2702", tagId2: "2857", device: "9231" },
        { text: "Çalışma Durumu", tagId: "2702" },
        { text: "Fan Modu", tagId: "8157", tagId2: "2858" },

        { text: "Filtre Durumu", tagId: "1343" },
        { text: "Filtre Reset", tagId: "1619" },
        { text: "Arıza Durumu", tagId: "7234" },
        { text: "Arıza Kodu", tagId: "2701" },
      ],
    },
    {
      // DESK ÜSTÜ
      802: [
        { text: "Oda Sıcaklığı", tagId: "974" },
        { text: "Oda Set Değeri", tagId: "1123", device: "9238" },
        { text: "Cihaz", tagId: "1345", tagId2: "1458", device: "9235" },
        { text: "Çalışma Modu", tagId: "2706", tagId2: "2860", device: "9236" },
        { text: "Çalışma Durumu", tagId: "2706" },

        { text: "Fan Modu", tagId: "8161", tagId2: "2861" },

        { text: "Filtre Durumu", tagId: "1347" },
        { text: "Filtre Reset", tagId: "1626" },
        { text: "Arıza Durumu", tagId: "7237" },
        { text: "Arıza Kodu", tagId: "2705" },
      ],
    },
    {
      // GÜVELİK OFİSİ
      803: [
        { text: "Oda Sıcaklığı", tagId: "975" },
        { text: "Oda Set Değeri", tagId: "1129", device: "9243" },
        { text: "Cihaz", tagId: "1349", tagId2: "1459", device: "9240" },
        { text: "Çalışma Modu", tagId: "2710", tagId2: "2863", device: "9241" },
        { text: "Çalışma Durumu", tagId: "2710" },
        { text: "Fan Modu", tagId: "8165", tagId2: "2864" },

        { text: "Filtre Durumu", tagId: "1351" },
        { text: "Filtre Reset", tagId: "1633" },
        { text: "Arıza Durumu", tagId: "7340" },
        { text: "Arıza Kodu", tagId: "2709" },
      ],
    },
    {
      // BULAŞIKHANE
      804: [
        { text: "Oda Sıcaklığı", tagId: "976" },
        { text: "Oda Set Değeri", tagId: "1135", device: "9248" },
        { text: "Cihaz", tagId: "1353", tagId2: "1460", device: "9245" },
        { text: "Çalışma Modu", tagId: "2714", tagId2: "2866", device: "9246" },
        { text: "Çalışma Durumu", tagId: "2714" },

        { text: "Fan Modu", tagId: "8169", tagId2: "2867" },

        { text: "Filtre Durumu", tagId: "1355" },
        { text: "Filtre Reset", tagId: "1640" },
        { text: "Arıza Durumu", tagId: "7243" },
        { text: "Arıza Kodu", tagId: "2713" },
      ],
    },
    {
      // YEMEKHANE 1
      805: [
        { text: "Oda Sıcaklığı", tagId: "977" },
        { text: "Oda Set Değeri", tagId: "1141", device: "9253" },
        { text: "Cihaz", tagId: "1357", tagId2: "1461", device: "9250" },
        { text: "Çalışma Modu", tagId: "2718", tagId2: "2869", device: "9251" },
        { text: "Çalışma Durumu", tagId: "2718" },
        { text: "Fan Modu", tagId: "8173", tagId2: "2870" },

        { text: "Filtre Durumu", tagId: "1359" },
        { text: "Filtre Reset", tagId: "1647" },
        { text: "Arıza Durumu", tagId: "7246" },
        { text: "Arıza Kodu", tagId: "2717" },
      ],
    },
    {
      // YEMEKHANE 2
      806: [
        { text: "Oda Sıcaklığı", tagId: "978" },
        { text: "Oda Set Değeri", tagId: "1147", device: "9258" },
        { text: "Cihaz", tagId: "1361", tagId2: "1462", device: "9255" },
        { text: "Çalışma Modu", tagId: "2722", tagId2: "2872", device: "9256" },
        { text: "Çalışma Durumu", tagId: "2722" },

        { text: "Fan Modu", tagId: "8177", tagId2: "2873" },

        { text: "Filtre Durumu", tagId: "1363" },
        { text: "Filtre Reset", tagId: "1654" },
        { text: "Arıza Durumu", tagId: "7249" },
        { text: "Arıza Kodu", tagId: "2721" },
      ],
    },
    {
      // FOR FUN BAR
      807: [
        { text: "Oda Sıcaklığı", tagId: "979" },
        { text: "Oda Set Değeri", tagId: "1153", device: "9263" },
        { text: "Cihaz", tagId: "1365", tagId2: "1463", device: "9260" },
        { text: "Çalışma Modu", tagId: "2726", tagId2: "2875", device: "9261" },
        { text: "Çalışma Durumu", tagId: "2726" },
        { text: "Fan Modu", tagId: "8181", tagId2: "2876" },

        { text: "Filtre Durumu", tagId: "1367" },
        { text: "Filtre Reset", tagId: "1661" },
        { text: "Arıza Durumu", tagId: "7252" },
        { text: "Arıza Kodu", tagId: "2725" },
      ],
    },
    {
      // FOR FUN WC
      808: [
        { text: "Oda Sıcaklığı", tagId: "980" },
        { text: "Oda Set Değeri", tagId: "1159", device: "9268" },
        { text: "Cihaz", tagId: "1369", tagId2: "1464", device: "9265" },
        { text: "Çalışma Modu", tagId: "2730", tagId2: "2878", device: "9266" },
        { text: "Çalışma Durumu", tagId: "2730" },

        { text: "Fan Modu", tagId: "8185", tagId2: "2879" },

        { text: "Filtre Durumu", tagId: "1371" },
        { text: "Filtre Reset", tagId: "1668" },
        { text: "Arıza Durumu", tagId: "7255" },
        { text: "Arıza Kodu", tagId: "2729" },
      ],
    },
    {
      // FOR FUN WC 2
      809: [
        { text: "Oda Sıcaklığı", tagId: "981" },
        { text: "Oda Set Değeri", tagId: "1165", device: "9273" },
        { text: "Cihaz", tagId: "1373", tagId2: "1465", device: "9270" },
        { text: "Çalışma Modu", tagId: "8732", tagId2: "8731", device: "9271" },
        { text: "Çalışma Durumu", tagId: "8732" },
        { text: "Fan Modu", tagId: "8189", tagId2: "2881" },

        { text: "Filtre Durumu", tagId: "1375" },
        { text: "Filtre Reset", tagId: "1675" },
        { text: "Arıza Durumu", tagId: "7258" },
        { text: "Arıza Kodu", tagId: "2733" },
      ],
    },
    {
      // KARAOKE 1
      810: [
        { text: "Oda Sıcaklığı", tagId: "982" },
        { text: "Oda Set Değeri", tagId: "1171", device: "9278" },
        { text: "Cihaz", tagId: "1377", tagId2: "1466", device: "9275" },
        { text: "Çalışma Modu", tagId: "2738", tagId2: "2884", device: "9276" },
        { text: "Çalışma Durumu", tagId: "2738" },

        { text: "Fan Modu", tagId: "8193", tagId2: "2885" },

        { text: "Filtre Durumu", tagId: "1379" },
        { text: "Filtre Reset", tagId: "1681" },
        { text: "Arıza Durumu", tagId: "7261" },
        { text: "Arıza Kodu", tagId: "2737" },
      ],
    },
    {
      // DANS ODASI
      811: [
        { text: "Oda Sıcaklığı", tagId: "983" },
        { text: "Oda Set Değeri", tagId: "1177", device: "9283" },
        { text: "Cihaz", tagId: "1381", tagId2: "1467", device: "9280" },
        { text: "Çalışma Modu", tagId: "2742", tagId2: "2887", device: "9281" },
        { text: "Çalışma Durumu", tagId: "2742" },
        { text: "Fan Modu", tagId: "8197", tagId2: "2888" },

        { text: "Filtre Durumu", tagId: "1383" },
        { text: "Filtre Reset", tagId: "1688" },
        { text: "Arıza Durumu", tagId: "7264" },
        { text: "Arıza Kodu", tagId: "2741" },
      ],
    },
    {
      // KARAOKE 2
      812: [
        { text: "Oda Sıcaklığı", tagId: "984" },
        { text: "Oda Set Değeri", tagId: "1183", device: "9288" },
        { text: "Cihaz", tagId: "1385", tagId2: "1468", device: "9285" },
        { text: "Çalışma Modu", tagId: "2746", tagId2: "2890", device: "9286" },
        { text: "Çalışma Durumu", tagId: "2746" },

        { text: "Fan Modu", tagId: "8201", tagId2: "2891" },

        { text: "Filtre Durumu", tagId: "1387" },
        { text: "Filtre Reset", tagId: "1695" },
        { text: "Arıza Durumu", tagId: "7267" },
        { text: "Arıza Kodu", tagId: "2745" },
      ],
    },
    {
      // OYUN SALONU TEKNİK ÖNÜ
      813: [
        { text: "Oda Sıcaklığı", tagId: "985" },
        { text: "Oda Set Değeri", tagId: "1189", device: "9293" },
        { text: "Cihaz", tagId: "1389", tagId2: "1469", device: "9290" },
        { text: "Çalışma Modu", tagId: "2750", tagId2: "2893", device: "9291" },
        { text: "Çalışma Durumu", tagId: "2750" },
        { text: "Fan Modu", tagId: "8205", tagId2: "2894" },

        { text: "Filtre Durumu", tagId: "1391" },
        { text: "Filtre Reset", tagId: "1702" },
        { text: "Arıza Durumu", tagId: "7270" },
        { text: "Arıza Kodu", tagId: "2749" },
      ],
    },
    // {
    //   // LAZER ALANI
    //   814: [
    //     { text: "Oda Sıcaklığı", tagId: "5059" },
    //     { text: "Oda Set Değeri", tagId: "8706" },
    //     { text: "Cihaz", tagId: "8713", tagId2: "8710" },
    //     { text: "Çalışma Modu", tagId: "8719", tagId2: "8725" },
    //     { text: "Çalışma Durumu", tagId: "8719" },

    //     { text: "Fan Modu", tagId: "8209", tagId2: "8726" },

    //     { text: "Filtre Durumu", tagId: "8714" },
    //     { text: "Filtre Reset", tagId: "8722" },
    //     { text: "Arıza Durumu", tagId: "7273" },
    //     { text: "Arıza Kodu", tagId: "8720" },
    //   ],
    // },
    // {
    //   // LAZER ALANI 2
    //   815: [
    //     { text: "Oda Sıcaklığı", tagId: "5060" },
    //     { text: "Oda Set Değeri", tagId: "8703" },
    //     { text: "Cihaz", tagId: "8711", tagId2: "8709" },
    //     { text: "Çalışma Modu", tagId: "8717", tagId2: "8723" },
    //     { text: "Çalışma Durumu", tagId: "8717" },
    //     { text: "Fan Modu", tagId: "8213", tagId2: "8724" },

    //     { text: "Filtre Durumu", tagId: "8712" },
    //     { text: "Filtre Reset", tagId: "8721" },
    //     { text: "Arıza Durumu", tagId: "7276" },
    //     { text: "Arıza Kodu", tagId: "8718" },
    //   ],
    // },
    // {
    //   // LAZER ALANI 3
    //   816: [
    //     { text: "Oda Sıcaklığı", tagId: "5061" },
    //     { text: "Oda Set Değeri", tagId: "8706" },
    //     { text: "Cihaz", tagId: "8713", tagId2: "8710" },
    //     { text: "Çalışma Modu", tagId: "8719", tagId2: "8725" },
    //     { text: "Çalışma Durumu", tagId: "8719" },

    //     { text: "Fan Modu", tagId: "8217", tagId2: "8726" },

    //     { text: "Filtre Durumu", tagId: "8714" },
    //     { text: "Filtre Reset", tagId: "8722" },
    //     { text: "Arıza Durumu", tagId: "7279" },
    //     { text: "Arıza Kodu", tagId: "8720" },
    //   ],
    // },
  ];

  let vrf4_state = [
    {
      401: [
        { text: "Oda Sıcaklığı", tagId: "5040" },
        { text: "Oda Set Değeri", tagId: "5154", device: "9925" },
        { text: "Cihaz", tagId: "5390", tagId2: "5524", device: "9922" },
        { text: "Çalışma Modu", tagId: "6671", tagId2: "6832", device: "9923" },
        { text: "Çalışma Durumu", tagId: "6671" },

        { text: "Fan Modu", tagId: "6672", tagId2: "6833" },
        { text: "Soğutma Modu Set Değeri", tagId: "5155" },
        { text: "Isıtma Modu Set Değeri", tagId: "5156" },
        { text: "Filtre Durumu", tagId: "5392" },
        { text: "Filtre Reset", tagId: "5638" },
        { text: "Arıza Durumu", tagId: "8583" },
        { text: "Arıza Kodu", tagId: "6670" },
      ],
    },
    {
      402: [
        { text: "Oda Sıcaklığı", tagId: "5039" },
        { text: "Oda Set Değeri", tagId: "5148", device: "9919" },
        { text: "Cihaz", tagId: "5386", tagId2: "5523", device: "9916" },
        { text: "Çalışma Modu", tagId: "6667", tagId2: "6829", device: "9917" },
        { text: "Çalışma Durumu", tagId: "6667" },

        { text: "Fan Modu", tagId: "6668", tagId2: "6830" },
        { text: "Soğutma Modu Set Değeri", tagId: "5149" },
        { text: "Isıtma Modu Set Değeri", tagId: "5150" },
        { text: "Filtre Durumu", tagId: "5388" },
        { text: "Filtre Reset", tagId: "5632" },
        { text: "Arıza Durumu", tagId: "8579" },
        { text: "Arıza Kodu", tagId: "6666" },
      ],
    },
    {
      403: [
        { text: "Oda Sıcaklığı", tagId: "5038" },
        { text: "Oda Set Değeri", tagId: "5142", device: "9913" },
        { text: "Cihaz", tagId: "5382", tagId2: "5522", device: "9910" },
        { text: "Çalışma Modu", tagId: "6663", tagId2: "6826", device: "9911" },
        { text: "Çalışma Durumu", tagId: "6663" },

        { text: "Fan Modu", tagId: "6664", tagId2: "6827" },
        { text: "Soğutma Modu Set Değeri", tagId: "5143" },
        { text: "Isıtma Modu Set Değeri", tagId: "5144" },
        { text: "Filtre Durumu", tagId: "5384" },
        { text: "Filtre Reset", tagId: "5626" },
        { text: "Arıza Durumu", tagId: "8575" },
        { text: "Arıza Kodu", tagId: "6662" },
      ],
    },
    {
      404: [
        { text: "Oda Sıcaklığı", tagId: "5037" },
        { text: "Oda Set Değeri", tagId: "5136", device: "9907" },
        { text: "Cihaz", tagId: "5378", tagId2: "5521", device: "9904" },
        { text: "Çalışma Modu", tagId: "6659", tagId2: "6823", device: "9905" },
        { text: "Çalışma Durumu", tagId: "6659" },

        { text: "Fan Modu", tagId: "6660", tagId2: "6824" },
        { text: "Soğutma Modu Set Değeri", tagId: "5137" },
        { text: "Isıtma Modu Set Değeri", tagId: "5138" },
        { text: "Filtre Durumu", tagId: "5380" },
        { text: "Filtre Reset", tagId: "5620" },
        { text: "Arıza Durumu", tagId: "8571" },
        { text: "Arıza Kodu", tagId: "6658" },
      ],
    },
    {
      405: [
        { text: "Oda Sıcaklığı", tagId: "5036" },
        { text: "Oda Set Değeri", tagId: "5130", device: "9901" },
        { text: "Cihaz", tagId: "5374", tagId2: "5520", device: "9898" },
        { text: "Çalışma Modu", tagId: "6655", tagId2: "6820", device: "9899" },
        { text: "Çalışma Durumu", tagId: "6655" },

        { text: "Fan Modu", tagId: "6656", tagId2: "6821" },
        { text: "Soğutma Modu Set Değeri", tagId: "5131" },
        { text: "Isıtma Modu Set Değeri", tagId: "5132" },
        { text: "Filtre Durumu", tagId: "5376" },
        { text: "Filtre Reset", tagId: "5614" },
        { text: "Arıza Durumu", tagId: "8567" },
        { text: "Arıza Kodu", tagId: "6654" },
      ],
    },
    {
      406: [
        { text: "Oda Sıcaklığı", tagId: "5035" },
        { text: "Oda Set Değeri", tagId: "5124", device: "9895" },
        { text: "Cihaz", tagId: "5370", tagId2: "5519", device: "9892" },
        { text: "Çalışma Modu", tagId: "6651", tagId2: "6817", device: "9893" },
        { text: "Çalışma Durumu", tagId: "6651" },

        { text: "Fan Modu", tagId: "6652", tagId2: "6818" },
        { text: "Soğutma Modu Set Değeri", tagId: "5125" },
        { text: "Isıtma Modu Set Değeri", tagId: "5126" },
        { text: "Filtre Durumu", tagId: "5372" },
        { text: "Filtre Reset", tagId: "5608" },
        { text: "Arıza Durumu", tagId: "8563" },
        { text: "Arıza Kodu", tagId: "6650" },
      ],
    },
    {
      407: [
        { text: "Oda Sıcaklığı", tagId: "5034" },
        { text: "Oda Set Değeri", tagId: "5118", device: "9889" },
        { text: "Cihaz", tagId: "5366", tagId2: "5518", device: "9886" },
        { text: "Çalışma Modu", tagId: "6647", tagId2: "6814", device: "9887" },
        { text: "Çalışma Durumu", tagId: "6647" },

        { text: "Fan Modu", tagId: "6648", tagId2: "6815" },
        { text: "Soğutma Modu Set Değeri", tagId: "5119" },
        { text: "Isıtma Modu Set Değeri", tagId: "5120" },
        { text: "Filtre Durumu", tagId: "5368" },
        { text: "Filtre Reset", tagId: "5602" },
        { text: "Arıza Durumu", tagId: "8559" },
        { text: "Arıza Kodu", tagId: "6646" },
      ],
    },
    {
      408: [
        { text: "Oda Sıcaklığı", tagId: "5033" },
        { text: "Oda Set Değeri", tagId: "5112", device: "9883" },
        { text: "Cihaz", tagId: "5362", tagId2: "5517", device: "9880" },
        { text: "Çalışma Modu", tagId: "6643", tagId2: "6811", device: "9881" },
        { text: "Çalışma Durumu", tagId: "6643" },

        { text: "Fan Modu", tagId: "6644", tagId2: "6812" },
        { text: "Soğutma Modu Set Değeri", tagId: "5113" },
        { text: "Isıtma Modu Set Değeri", tagId: "5114" },
        { text: "Filtre Durumu", tagId: "5364" },
        { text: "Filtre Reset", tagId: "5596" },
        { text: "Arıza Durumu", tagId: "8555" },
        { text: "Arıza Kodu", tagId: "6642" },
      ],
    },
  ];

  let vrf3_state = [
    {
      301: [
        { text: "Oda Sıcaklığı", tagId: "5053" },
        { text: "Oda Set Değeri", tagId: "5232", device: "10003" },
        { text: "Cihaz", tagId: "5442", tagId2: "5537", device: "10000" },
        {
          text: "Çalışma Modu",
          tagId: "6723",
          tagId2: "6871",
          device: "10001",
        },
        { text: "Çalışma Durumu", tagId: "6723", tagId2: "6871" },

        { text: "Fan Modu", tagId: "6724", tagId2: "6872" },
        { text: "Soğutma Modu Set Değeri", tagId: "5233" },
        { text: "Isıtma Modu Set Değeri", tagId: "5234" },
        { text: "Filtre Durumu", tagId: "5444" },
        { text: "Filtre Reset", tagId: "5716" },
        { text: "Arıza Durumu", tagId: "8635" },
        { text: "Arıza Kodu", tagId: "6722" },
      ],
    },
    {
      302: [
        { text: "Oda Sıcaklığı", tagId: "5052" },
        { text: "Oda Set Değeri", tagId: "5226", device: "9997" },
        { text: "Cihaz", tagId: "5438", tagId2: "5536", device: "9994" },
        { text: "Çalışma Modu", tagId: "6719", tagId2: "6868", device: "9995" },
        { text: "Çalışma Durumu", tagId: "6719", tagId2: "6868" },

        { text: "Fan Modu", tagId: "6720", tagId2: "6869" },
        { text: "Soğutma Modu Set Değeri", tagId: "5227" },
        { text: "Isıtma Modu Set Değeri", tagId: "5228" },
        { text: "Filtre Durumu", tagId: "5440" },
        { text: "Filtre Reset", tagId: "5710" },
        { text: "Arıza Durumu", tagId: "8631" },
        { text: "Arıza Kodu", tagId: "6718" },
      ],
    },
    {
      303: [
        { text: "Oda Sıcaklığı", tagId: "5051" },
        { text: "Oda Set Değeri", tagId: "5220", device: "9991" },
        { text: "Cihaz", tagId: "5434", tagId2: "5535", device: "9988" },
        { text: "Çalışma Modu", tagId: "6715", tagId2: "6865", device: "9989" },
        { text: "Çalışma Durumu", tagId: "6715", tagId2: "6865" },

        { text: "Fan Modu", tagId: "6716", tagId2: "6866" },
        { text: "Soğutma Modu Set Değeri", tagId: "5221" },
        { text: "Isıtma Modu Set Değeri", tagId: "5222" },
        { text: "Filtre Durumu", tagId: "5436" },
        { text: "Filtre Reset", tagId: "5704" },
        { text: "Arıza Durumu", tagId: "8627" },
        { text: "Arıza Kodu", tagId: "6714" },
      ],
    },
    {
      304: [
        { text: "Oda Sıcaklığı", tagId: "5050" },
        { text: "Oda Set Değeri", tagId: "5214", device: "9985" },
        { text: "Cihaz", tagId: "5430", tagId2: "5534", device: "9982" },
        { text: "Çalışma Modu", tagId: "6711", tagId2: "6862", device: "9983" },
        { text: "Çalışma Durumu", tagId: "6711", tagId2: "6862" },

        { text: "Fan Modu", tagId: "6712", tagId2: "6863" },
        { text: "Soğutma Modu Set Değeri", tagId: "5215" },
        { text: "Isıtma Modu Set Değeri", tagId: "5216" },
        { text: "Filtre Durumu", tagId: "5432" },
        { text: "Filtre Reset", tagId: "5698" },
        { text: "Arıza Durumu", tagId: "8623" },
        { text: "Arıza Kodu", tagId: "6710" },
      ],
    },
    {
      305: [
        { text: "Oda Sıcaklığı", tagId: "5049" },
        { text: "Oda Set Değeri", tagId: "5208", device: "9979" },
        { text: "Cihaz", tagId: "5426", tagId2: "5533", device: "9976" },
        { text: "Çalışma Modu", tagId: "6707", tagId2: "6859", device: "9977" },
        { text: "Çalışma Durumu", tagId: "6707", tagId2: "6859" },

        { text: "Fan Modu", tagId: "6708", tagId2: "6860" },
        { text: "Soğutma Modu Set Değeri", tagId: "5209" },
        { text: "Isıtma Modu Set Değeri", tagId: "5210" },
        { text: "Filtre Durumu", tagId: "5428" },
        { text: "Filtre Reset", tagId: "5692" },
        { text: "Arıza Durumu", tagId: "8619" },
        { text: "Arıza Kodu", tagId: "6706" },
      ],
    },
    {
      306: [
        { text: "Oda Sıcaklığı", tagId: "5048" },
        { text: "Oda Set Değeri", tagId: "5202", device: "9973" },
        { text: "Cihaz", tagId: "5422", tagId2: "5532", device: "9970" },
        { text: "Çalışma Modu", tagId: "6703", tagId2: "6856", device: "9971" },
        { text: "Çalışma Durumu", tagId: "6703", tagId2: "6856" },

        { text: "Fan Modu", tagId: "6704", tagId2: "6857" },
        { text: "Soğutma Modu Set Değeri", tagId: "5203" },
        { text: "Isıtma Modu Set Değeri", tagId: "5204" },
        { text: "Filtre Durumu", tagId: "5424" },
        { text: "Filtre Reset", tagId: "5686" },
        { text: "Arıza Durumu", tagId: "8615" },
        { text: "Arıza Kodu", tagId: "6702" },
      ],
    },
    {
      307: [
        { text: "Oda Sıcaklığı", tagId: "5047" },
        { text: "Oda Set Değeri", tagId: "5196", device: "9967" },
        { text: "Cihaz", tagId: "5418", tagId2: "5531", device: "9964" },
        { text: "Çalışma Modu", tagId: "6699", tagId2: "6853", device: "9965" },
        { text: "Çalışma Durumu", tagId: "6699", tagId2: "6853" },

        { text: "Fan Modu", tagId: "6700", tagId2: "6854" },
        { text: "Soğutma Modu Set Değeri", tagId: "5197" },
        { text: "Isıtma Modu Set Değeri", tagId: "5198" },
        { text: "Filtre Durumu", tagId: "5420" },
        { text: "Filtre Reset", tagId: "5680" },
        { text: "Arıza Durumu", tagId: "8611" },
        { text: "Arıza Kodu", tagId: "6698" },
      ],
    },
    {
      308: [
        { text: "Oda Sıcaklığı", tagId: "5046" },
        { text: "Oda Set Değeri", tagId: "5190", device: "9961" },
        { text: "Cihaz", tagId: "5414", tagId2: "5530", device: "9958" },
        { text: "Çalışma Modu", tagId: "6695", tagId2: "6850", device: "9959" },
        { text: "Çalışma Durumu", tagId: "6695", tagId2: "6850" },

        { text: "Fan Modu", tagId: "6699", tagId2: "6851" },
        { text: "Soğutma Modu Set Değeri", tagId: "5191" },
        { text: "Isıtma Modu Set Değeri", tagId: "5192" },
        { text: "Filtre Durumu", tagId: "5416" },
        { text: "Filtre Reset", tagId: "5674" },
        { text: "Arıza Durumu", tagId: "8607" },
        { text: "Arıza Kodu", tagId: "6694" },
      ],
    },
    {
      309: [
        { text: "Oda Sıcaklığı", tagId: "5045" },
        { text: "Oda Set Değeri", tagId: "5184", device: "9955" },
        { text: "Cihaz", tagId: "5410", tagId2: "5529", device: "9952" },
        { text: "Çalışma Modu", tagId: "6691", tagId2: "6847", device: "9953" },
        { text: "Çalışma Durumu", tagId: "6691", tagId2: "6847" },

        { text: "Fan Modu", tagId: "6692", tagId2: "6848" },
        { text: "Soğutma Modu Set Değeri", tagId: "5185" },
        { text: "Isıtma Modu Set Değeri", tagId: "5186" },
        { text: "Filtre Durumu", tagId: "5412" },
        { text: "Filtre Reset", tagId: "5668" },
        { text: "Arıza Durumu", tagId: "8603" },
        { text: "Arıza Kodu", tagId: "6690" },
      ],
    },
    {
      310: [
        { text: "Oda Sıcaklığı", tagId: "5044" },
        { text: "Oda Set Değeri", tagId: "5178", device: "9949" },
        { text: "Cihaz", tagId: "5406", tagId2: "5528", device: "9946" },
        { text: "Çalışma Modu", tagId: "6687", tagId2: "6844", device: "9947" },
        { text: "Çalışma Durumu", tagId: "6687", tagId2: "6844" },

        { text: "Fan Modu", tagId: "6688", tagId2: "6845" },
        { text: "Soğutma Modu Set Değeri", tagId: "5179" },
        { text: "Isıtma Modu Set Değeri", tagId: "5180" },
        { text: "Filtre Durumu", tagId: "5408" },
        { text: "Filtre Reset", tagId: "5662" },
        { text: "Arıza Durumu", tagId: "8599" },
        { text: "Arıza Kodu", tagId: "6686" },
      ],
    },

    {
      311: [
        { text: "Oda Sıcaklığı", tagId: "5043" },
        { text: "Oda Set Değeri", tagId: "5172", device: "9943" },
        { text: "Cihaz", tagId: "5402", tagId2: "5527", device: "9940" },
        { text: "Çalışma Modu", tagId: "6683", tagId2: "6841", device: "9941" },
        { text: "Çalışma Durumu", tagId: "6683", tagId2: "6841" },

        { text: "Fan Modu", tagId: "6684", tagId2: "6842" },
        { text: "Soğutma Modu Set Değeri", tagId: "5173" },
        { text: "Isıtma Modu Set Değeri", tagId: "5174" },
        { text: "Filtre Durumu", tagId: "5404" },
        { text: "Filtre Reset", tagId: "5656" },
        { text: "Arıza Durumu", tagId: "8595" },
        { text: "Arıza Kodu", tagId: "6682" },
      ],
    },
    {
      312: [
        { text: "Oda Sıcaklığı", tagId: "5042" },
        { text: "Oda Set Değeri", tagId: "5166", device: "9937" },
        { text: "Cihaz", tagId: "5398", tagId2: "5526", device: "9934" },
        { text: "Çalışma Modu", tagId: "6679", tagId2: "6838", device: "9935" },
        { text: "Çalışma Durumu", tagId: "6679", tagId2: "6838" },

        { text: "Fan Modu", tagId: "6680", tagId2: "6839" },
        { text: "Soğutma Modu Set Değeri", tagId: "5167" },
        { text: "Isıtma Modu Set Değeri", tagId: "5168" },
        { text: "Filtre Durumu", tagId: "5400" },
        { text: "Filtre Reset", tagId: "5650" },
        { text: "Arıza Durumu", tagId: "8591" },
        { text: "Arıza Kodu", tagId: "6678" },
      ],
    },
  ];

  let vrf2_state = [
    {
      201: [
        { text: "Oda Sıcaklığı", tagId: "5055" },
        { text: "Oda Set Değeri", tagId: "5244", device: "10015" },
        { text: "Cihaz", tagId: "5450", tagId2: "5539", device: "10012" },
        {
          text: "Çalışma Modu",
          tagId: "6731",
          tagId2: "6877",
          device: "10013",
        },
        { text: "Çalışma Durumu", tagId: "6731", tagId2: "6877" },

        { text: "Fan Modu", tagId: "6732", tagId2: "6878" },
        { text: "Soğutma Modu Set Değeri", tagId: "5245" },
        { text: "Isıtma Modu Set Değeri", tagId: "5246" },
        { text: "Filtre Durumu", tagId: "5452" },
        { text: "Filtre Reset", tagId: "5728" },
        { text: "Arıza Durumu", tagId: "8643" },
        { text: "Arıza Kodu", tagId: "6730" },
      ],
    },
    {
      202: [
        { text: "Oda Sıcaklığı", tagId: "5056" },
        { text: "Oda Set Değeri", tagId: "5250", device: "10021" },
        { text: "Cihaz", tagId: "5454", tagId2: "5540", device: "10018" },
        {
          text: "Çalışma Modu",
          tagId: "6735",
          tagId2: "6880",
          device: "10019",
        },
        { text: "Çalışma Durumu", tagId: "6735", tagId2: "6880" },

        { text: "Fan Modu", tagId: "6736", tagId2: "6881" },
        { text: "Soğutma Modu Set Değeri", tagId: "5251" },
        { text: "Isıtma Modu Set Değeri", tagId: "5252" },
        { text: "Filtre Durumu", tagId: "5456" },
        { text: "Filtre Reset", tagId: "5734" },
        { text: "Arıza Durumu", tagId: "8647" },
        { text: "Arıza Kodu", tagId: "6734" },
      ],
    },
    {
      203: [
        { text: "Oda Sıcaklığı", tagId: "5057" },
        { text: "Oda Set Değeri", tagId: "5256", device: "10027" },
        { text: "Cihaz", tagId: "5458", tagId2: "5541", device: "10024" },
        {
          text: "Çalışma Modu",
          tagId: "6739",
          tagId2: "6883",
          device: "10025",
        },
        { text: "Çalışma Durumu", tagId: "6739", tagId2: "6883" },

        { text: "Fan Modu", tagId: "6740", tagId2: "6884" },
        { text: "Soğutma Modu Set Değeri", tagId: "5257" },
        { text: "Isıtma Modu Set Değeri", tagId: "5258" },
        { text: "Filtre Durumu", tagId: "5460" },
        { text: "Filtre Reset", tagId: "5740" },
        { text: "Arıza Durumu", tagId: "8651" },
        { text: "Arıza Kodu", tagId: "6738" },
      ],
    },
    {
      204: [
        { text: "Oda Sıcaklığı", tagId: "5058" },
        { text: "Oda Set Değeri", tagId: "5262", device: "10033" },
        { text: "Cihaz", tagId: "5462", tagId2: "5542", device: "10030" },
        {
          text: "Çalışma Modu",
          tagId: "6743",
          tagId2: "6886",
          device: "10031",
        },
        { text: "Çalışma Durumu", tagId: "6743", tagId2: "6886" },

        { text: "Fan Modu", tagId: "6744", tagId2: "6887" },
        { text: "Soğutma Modu Set Değeri", tagId: "5263" },
        { text: "Isıtma Modu Set Değeri", tagId: "5264" },
        { text: "Filtre Durumu", tagId: "5464" },
        { text: "Filtre Reset", tagId: "5746" },
        { text: "Arıza Durumu", tagId: "8655" },
        { text: "Arıza Kodu", tagId: "6742" },
      ],
    },
    {
      205: [
        { text: "Oda Sıcaklığı", tagId: "5059" },
        { text: "Oda Set Değeri", tagId: "5268", device: "10039" },
        { text: "Cihaz", tagId: "5466", tagId2: "5543", device: "10036" },
        {
          text: "Çalışma Modu",
          tagId: "6747",
          tagId2: "6889",
          device: "10037",
        },
        { text: "Çalışma Durumu", tagId: "6747", tagId2: "6889" },

        { text: "Fan Modu", tagId: "6748", tagId2: "6890" },
        { text: "Soğutma Modu Set Değeri", tagId: "5269" },
        { text: "Isıtma Modu Set Değeri", tagId: "5270" },
        { text: "Filtre Durumu", tagId: "5468" },
        { text: "Filtre Reset", tagId: "5752" },
        { text: "Arıza Durumu", tagId: "8659" },
        { text: "Arıza Kodu", tagId: "6746" },
      ],
    },
    {
      206: [
        { text: "Oda Sıcaklığı", tagId: "5060" },
        { text: "Oda Set Değeri", tagId: "5274", device: "10045" },
        { text: "Cihaz", tagId: "5470", tagId2: "5544", device: "10042" },
        {
          text: "Çalışma Modu",
          tagId: "6751",
          tagId2: "6892",
          device: "10043",
        },
        { text: "Çalışma Durumu", tagId: "6751", tagId2: "6892" },

        { text: "Fan Modu", tagId: "6752", tagId2: "6893" },
        { text: "Soğutma Modu Set Değeri", tagId: "5275" },
        { text: "Isıtma Modu Set Değeri", tagId: "5276" },
        { text: "Filtre Durumu", tagId: "5472" },
        { text: "Filtre Reset", tagId: "5758" },
        { text: "Arıza Durumu", tagId: "8663" },
        { text: "Arıza Kodu", tagId: "6750" },
      ],
    },
    {
      207: [
        { text: "Oda Sıcaklığı", tagId: "5061" },
        { text: "Oda Set Değeri", tagId: "5280", device: "10051" },
        { text: "Cihaz", tagId: "5474", tagId2: "5545", device: "10048" },
        {
          text: "Çalışma Modu",
          tagId: "6755",
          tagId2: "6895",
          device: "10049",
        },
        { text: "Çalışma Durumu", tagId: "6755", tagId2: "6895" },

        { text: "Fan Modu", tagId: "6756", tagId2: "6896" },
        { text: "Soğutma Modu Set Değeri", tagId: "5281" },
        { text: "Isıtma Modu Set Değeri", tagId: "5282" },
        { text: "Filtre Durumu", tagId: "5476" },
        { text: "Filtre Reset", tagId: "5764" },
        { text: "Arıza Durumu", tagId: "8667" },
        { text: "Arıza Kodu", tagId: "6754" },
      ],
    },
    {
      208: [
        { text: "Oda Sıcaklığı", tagId: "5062" },
        { text: "Oda Set Değeri", tagId: "5286", device: "10057" },
        { text: "Cihaz", tagId: "5478", tagId2: "5546", device: "10054" },
        {
          text: "Çalışma Modu",
          tagId: "6759",
          tagId2: "6898",
          device: "10055",
        },
        { text: "Çalışma Durumu", tagId: "6759", tagId2: "6898" },

        { text: "Fan Modu", tagId: "6760", tagId2: "6899" },
        { text: "Soğutma Modu Set Değeri", tagId: "5287" },
        { text: "Isıtma Modu Set Değeri", tagId: "5288" },
        { text: "Filtre Durumu", tagId: "5480" },
        { text: "Filtre Reset", tagId: "5770" },
        { text: "Arıza Durumu", tagId: "8671" },
        { text: "Arıza Kodu", tagId: "6758" },
      ],
    },
    {
      209: [
        { text: "Oda Sıcaklığı", tagId: "5063" },
        { text: "Oda Set Değeri", tagId: "5292", device: "10063" },
        { text: "Cihaz", tagId: "5482", tagId2: "5547", device: "10060" },
        {
          text: "Çalışma Modu",
          tagId: "6763",
          tagId2: "6901",
          device: "10061",
        },
        { text: "Çalışma Durumu", tagId: "6763", tagId2: "6901" },

        { text: "Fan Modu", tagId: "6764", tagId2: "6902" },
        { text: "Soğutma Modu Set Değeri", tagId: "5293" },
        { text: "Isıtma Modu Set Değeri", tagId: "5294" },
        { text: "Filtre Durumu", tagId: "5484" },
        { text: "Filtre Reset", tagId: "5776" },
        { text: "Arıza Durumu", tagId: "8675" },
        { text: "Arıza Kodu", tagId: "6762" },
      ],
    },
    {
      210: [
        { text: "Oda Sıcaklığı", tagId: "5064" },
        { text: "Oda Set Değeri", tagId: "5298", device: "10069" },
        { text: "Cihaz", tagId: "5486", tagId2: "5548", device: "10066" },
        {
          text: "Çalışma Modu",
          tagId: "6767",
          tagId2: "6904",
          device: "10067",
        },
        { text: "Çalışma Durumu", tagId: "6767", tagId2: "6904" },

        { text: "Fan Modu", tagId: "6768", tagId2: "6905" },
        { text: "Soğutma Modu Set Değeri", tagId: "5299" },
        { text: "Isıtma Modu Set Değeri", tagId: "5300" },
        { text: "Filtre Durumu", tagId: "5488" },
        { text: "Filtre Reset", tagId: "5782" },
        { text: "Arıza Durumu", tagId: "8679" },
        { text: "Arıza Kodu", tagId: "6766" },
      ],
    },
    {
      211: [
        { text: "Oda Sıcaklığı", tagId: "5065" },
        { text: "Oda Set Değeri", tagId: "5304", device: "10075" },
        { text: "Cihaz", tagId: "5490", tagId2: "5549", device: "10072" },
        {
          text: "Çalışma Modu",
          tagId: "6771",
          tagId2: "6907",
          device: "10073",
        },
        { text: "Çalışma Durumu", tagId: "6771", tagId2: "6907" },

        { text: "Fan Modu", tagId: "6772", tagId2: "6908" },
        { text: "Soğutma Modu Set Değeri", tagId: "5305" },
        { text: "Isıtma Modu Set Değeri", tagId: "5306" },
        { text: "Filtre Durumu", tagId: "5492" },
        { text: "Filtre Reset", tagId: "5788" },
        { text: "Arıza Durumu", tagId: "8683" },
        { text: "Arıza Kodu", tagId: "6770" },
      ],
    },
    {
      212: [
        { text: "Oda Sıcaklığı", tagId: "5066" },
        { text: "Oda Set Değeri", tagId: "5310", device: "10081" },
        { text: "Cihaz", tagId: "5494", tagId2: "5550", device: "10078" },
        {
          text: "Çalışma Modu",
          tagId: "6775",
          tagId2: "6910",
          device: "10079",
        },
        { text: "Çalışma Durumu", tagId: "6775", tagId2: "6910" },

        { text: "Fan Modu", tagId: "6776", tagId2: "6911" },
        { text: "Soğutma Modu Set Değeri", tagId: "5311" },
        { text: "Isıtma Modu Set Değeri", tagId: "5312" },
        { text: "Filtre Durumu", tagId: "5496" },
        { text: "Filtre Reset", tagId: "5794" },
        { text: "Arıza Durumu", tagId: "8687" },
        { text: "Arıza Kodu", tagId: "6774" },
      ],
    },
    {
      213: [
        { text: "Oda Sıcaklığı", tagId: "5067" },
        { text: "Oda Set Değeri", tagId: "5316", device: "10087" },
        { text: "Cihaz", tagId: "5498", tagId2: "5551", device: "10084" },
        {
          text: "Çalışma Modu",
          tagId: "6779",
          tagId2: "6913",
          device: "10085",
        },
        { text: "Çalışma Durumu", tagId: "6779", tagId2: "6913" },

        { text: "Fan Modu", tagId: "6780", tagId2: "6914" },
        { text: "Soğutma Modu Set Değeri", tagId: "5317" },
        { text: "Isıtma Modu Set Değeri", tagId: "5318" },
        { text: "Filtre Durumu", tagId: "5500" },
        { text: "Filtre Reset", tagId: "5800" },
        { text: "Arıza Durumu", tagId: "8691" },
        { text: "Arıza Kodu", tagId: "6778" },
      ],
    },
    {
      214: [
        { text: "Oda Sıcaklığı", tagId: "5068" },
        { text: "Oda Set Değeri", tagId: "5322", device: "10093" },
        { text: "Cihaz", tagId: "5502", tagId2: "5552", device: "10090" },
        {
          text: "Çalışma Modu",
          tagId: "6783",
          tagId2: "6916",
          device: "10091",
        },
        { text: "Çalışma Durumu", tagId: "6783", tagId2: "6916" },

        { text: "Fan Modu", tagId: "6784", tagId2: "6917" },
        { text: "Soğutma Modu Set Değeri", tagId: "5323" },
        { text: "Isıtma Modu Set Değeri", tagId: "5324" },
        { text: "Filtre Durumu", tagId: "5504" },
        { text: "Filtre Reset", tagId: "5806" },
        { text: "Arıza Durumu", tagId: "8695" },
        { text: "Arıza Kodu", tagId: "6782" },
      ],
    },
  ];

  let vrf_teras = [
    {
      601: [
        { text: "Oda Sıcaklığı", tagId: "959" },
        { text: "Oda Set Değeri", tagId: "1033" },
        { text: "Cihaz", tagId: "1443" },
        { text: "Çalışma Modu", tagId: "2646" },
        { text: "Fan Modu", tagId: "2647" },
        { text: "Soğutma Modu Set Değeri", tagId: "1034" },
        { text: "Isıtma Modu Set Değeri", tagId: "1035" },
        { text: "Filtre Durumu", tagId: "1287" },
        { text: "Filtre Reset", tagId: "1522" },
        { text: "Arıza Durumu", tagId: "1286" },
        { text: "Arıza Kodu", tagId: "2645" },
      ],
    },
  ];

  let booster_state = [
    {
      "BOOSTER KAT 1 ": [
        { text: "Su Çıkış Sıcaklığı", tagId: "953" },
        { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "997" },
        { text: "Çalışma Durumu", tagId: "1261" },
        { text: "Arıza Durumu", tagId: "1262" },
        { text: "Arıza Kodu", tagId: "2621" },
        { text: "Çalış Dur Komutu", tagId: "1437", type: "btn" },
        { text: "Booster 1 Akımı", tagId: "133" },
        { text: "Booster 1 Enerji Sarfiyatı", tagId: "134" },
      ],
    },
    {
      "BOOSTER KAT 1 (LOBI TARAFI) ": [
        { text: "Su Çıkış Sıcaklığı", tagId: "972" },
        { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "1111" },
        { text: "Çalışma Durumu", tagId: "1337" },
        { text: "Arıza Durumu", tagId: "7231" },
        { text: "Arıza Kodu", tagId: "2697" },
        { text: "Çalış Dur Komutu", tagId: "1456", type: "btn" },
        { text: "Booster 1 Akımı", tagId: "8730" },
        { text: "Booster 1 Enerji Sarfiyatı", tagId: "8729" },
      ],
    },
    {
      "BOOSTER KAT 2": [
        { text: "Su Çıkış Sıcaklığı", tagId: "5054" },
        { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "5238" },
        { text: "Çalışma Durumu", tagId: "5446" },
        { text: "Arıza Durumu", tagId: "5447" },
        { text: "Arıza Kodu", tagId: "6726" },
        { text: "Çalış Dur Komutu", tagId: "5538", type: "btn" },
        { text: "Booster 2 Akımı", tagId: "139" },
        { text: "Booster 2 Enerji Sarfiyatı", tagId: "135" },
      ],
    },
    {
      "BOOSTER KAT 3": [
        { text: "Su Çıkış Sıcaklığı", tagId: "5041" },
        { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "5160" },
        { text: "Çalışma Durumu", tagId: "5394" },
        { text: "Arıza Durumu", tagId: "5395" },
        { text: "Arıza Kodu", tagId: "6674" },
        { text: "Çalış Dur Komutu", tagId: "5525", type: "btn" },
        { text: "Booster 3 Akımı", tagId: "140" },
        { text: "Booster 3 Enerji Sarfiyatı", tagId: "136" },
      ],
    },
    {
      "BOOSTER KAT 4": [
        { text: "Su Çıkış Sıcaklığı", tagId: "5069" },
        { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "5328" },
        { text: "Çalışma Durumu", tagId: "5506" },
        { text: "Arıza Durumu", tagId: "5507" },
        { text: "Arıza Kodu", tagId: "6786" },
        { text: "Çalış Dur Komutu", tagId: "5553", type: "btn" },
        { text: "Booster 4 Akımı", tagId: "141" },

        { text: "Booster 4 Enerji Sarfiyatı", tagId: "137" },
      ],
    },
    {
      "BOOSTER KAT 5 ": [
        { text: "Su Çıkış Sıcaklığı", tagId: "5026" },
        { text: "Su Çıkış Sıcaklığı Set Değeri", tagId: "5070" },
        { text: "Çalışma Durumu", tagId: "5334" },
        { text: "Arıza Durumu", tagId: "5335" },
        { text: "Arıza Kodu", tagId: "6614" },
        { text: "Çalış Dur Komutu", tagId: "5510", type: "btn" },
        { text: "Booster 5 Akımı", tagId: "142" },
        { text: "Booster 5 Enerji Sarfiyatı", tagId: "138" },
      ],
    },
  ];

  let fans_state = [
    {
      "WC Fan ": [
        { text: "WC Çalışma Durumu", tagId: "161" },
        { text: "WC Arıza Durumu", tagId: "162" },
        { text: "Faz 1 Voltaj", tagId: "150" },
        { text: "Faz 1 Akım", tagId: "153" },
        { text: "Faz 2 Voltaj", tagId: "151" },
        { text: "Faz 2 Akım", tagId: "154" },
        { text: "Faz 3 Voltaj", tagId: "152" },
        { text: "Faz 3 Akım", tagId: "155" },
        { text: "WC Fanı Toplam Enerji Sarfiyatı", tagId: "156" },
      ],
    },
    {
      "Davlumbaz Fan": [
        { text: "Davlumbaz Çalışma Durumu", tagId: "159" },
        { text: "Davlumbaz Arıza Durumu", tagId: "160" },
        { text: "Faz 1 Voltaj", tagId: "143" },
        { text: "Faz 1 Akım", tagId: "146" },
        { text: "Faz 2 Voltaj", tagId: "144" },
        { text: "Faz 2 Akım", tagId: "147" },
        { text: "Faz 3 Voltaj", tagId: "145" },
        { text: "Faz 3 Akım", tagId: "148" },
        { text: "Davlumbaz Fanı Toplam Enerji Sarfiyatı", tagId: "149" },
      ],
    },
  ];
  let temp_com_id = sessionStorage.getItem("TEMPCOM");
  if (temp_com_id) {
    temp_com_id = Number(temp_com_id);  // Direkt string'den number'a çevir
    Store.dispatch(set_temp_com_id(temp_com_id))
  }

  // Yetkilendirme güncellemesinin sonsuz döngüye girmemesi için ref kullanıyoruz
  const yetkilendirmeUpdatedRef = React.useRef(false);
  // Alarm interval'ını takip etmek için ref (sonsuz döngüyü önlemek için)
  const alarmIntervalRef = React.useRef(null);

  useEffect(() => {
    const updateYetkilendirme = async () => {
      // Eğer zaten güncellendiyse tekrar çalışma
      if (yetkilendirmeUpdatedRef.current) return;

      let idc = temp_com_id; // Use actual companyId

      if (
        props.auth_reducer !== "" &&
        props.pages_.length > 0 &&
        props.users_list.length > 0
      ) {
        const uid = props.auth_reducer;
        let old_yetki = null;
        props.users_list.forEach(a => {
          if (a.userId === props.auth_reducer && a.yetkilendirme) {
            old_yetki = JSON.parse(a.yetkilendirme)
          }
        })
        const name_list = [];
        const yetkilendirme = {};

        props.pages_.forEach((page) => {
          const hasAccess = old_yetki?.[idc] && old_yetki[idc][page.pageName];

          if (!hasAccess) {
            name_list.push(page.pageName);
          }
        });

        // Erişimi olmayan sayfalara default yetki ata
        name_list.forEach((name) => {
          yetkilendirme[name] = { "O": "f", "Y": "f", "S": "f" }; // veya false, sisteminiz nasıl çalışıyorsa
        });

        // Eğer eklenecek yeni yetki yoksa API çağrısı yapma
        if (name_list.length === 0) {
          yetkilendirmeUpdatedRef.current = true;
          return;
        }

        const updated_yetki = old_yetki
          ? {
            ...old_yetki,
            [idc]: {
              ...(old_yetki[idc] || {}),
              ...yetkilendirme,
            },
          }
          : { [idc]: { ...yetkilendirme } };


        try {
          const response = await axiosInstance.post("/person/SetYetkilendirme", {
            yetkilendirme: JSON.stringify(updated_yetki),
            userId: props.auth_reducer,
          });
          const data = response.data;

          if (response.status === 200 && data.length > 0) {
            const yetki_full = JSON.parse(data[0].yetkilendirme);
            const obj = {
              [uid]: yetki_full[idc]
            };

            // Flag'i güncelleme yapmadan ÖNCE set et (sonsuz döngüyü önlemek için)
            yetkilendirmeUpdatedRef.current = true;
            Store.dispatch(set_yetkilendirme_state(obj));
          }
        } catch (err) {
          console.error("Yetkilendirme güncelleme hatası:", err);
          yetkilendirmeUpdatedRef.current = true; // Hata durumunda da flag'i set et
        }
      }
    };

    updateYetkilendirme();
  }, [props.pages_, props.users_list, props.auth_reducer]);



  useEffect(() => {
    Set_company_id(props.company_id);
  }, [props.company_id]);

  // Path güncelleme - useEffect içine alındı (memory leak önlemi)
  useEffect(() => {
    const intervalId = setInterval(() => {
      var path = window.location.pathname.replace("_", " ");
      path = window.location.pathname.replace("ö", "o");
      path = window.location.pathname.replace("ü", "u");
      path = window.location.pathname.replace("Ö", "O");
      path = window.location.pathname.replace("Ü", "U");

      setPath(path);
    }, 100);

    return () => clearInterval(intervalId); // Cleanup
  }, []);

  var list = [];
  var list2 = [];

  let user_id;

  let com_id_;


  let ucer_id_;

  // 🔥 useLayoutEffect: URL parametrelerinden auth bilgilerini oku
  // DOM mount'tan hemen önce senkron çalışır, authentication check'ten ÖNCE
  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('user_id');
    const username = urlParams.get('username');
    const userEmail = urlParams.get('user_email');
    const userCompanyId = urlParams.get('user_companyId');
    const tokenFromUrl = urlParams.get('token');

    if (userId && username) {
      sessionStorage.setItem("user_id", userId);
      sessionStorage.setItem("username", decodeURIComponent(username));
      sessionStorage.setItem("user_email", decodeURIComponent(userEmail));
      sessionStorage.setItem("user_companyId", userCompanyId);
      Store.dispatch(set_uid(userId));
      Store.dispatch(set_username(decodeURIComponent(username)));
      Store.dispatch(set_email(decodeURIComponent(userEmail)));

      // 🔐 Store JWT token from URL (passed from TesisSec)
      if (tokenFromUrl) {
        sessionStorage.setItem('jwt_token', decodeURIComponent(tokenFromUrl));
        console.log("🔐 App.js: JWT Token restored from URL");
      }
    }
  }, []); // Empty dependency = sadece ilk mount'ta çalışır

  useEffect(() => {
    const componentDidMount = async () => {
      let path_current = window.location.pathname;
      await Store.dispatch(set_path(path_current));
    };

    // 🔥 Check URL for companyId parameter (from TesisSec)
    const urlParams = new URLSearchParams(window.location.search);
    const companyIdFromUrl = urlParams.get('companyId');
    if (companyIdFromUrl) {
      sessionStorage.setItem("TEMPCOM", companyIdFromUrl);
      sessionStorage.setItem("ucer_id", companyIdFromUrl);
      Store.dispatch(set_ucer_id(Number(companyIdFromUrl)));

      // 🔥 Set Tesis data so control_tesis > 0 and main page renders
      try {
        const isAkra = (companyIdFromUrl === "1" || companyIdFromUrl === "2");
        const tesisData = { "Akra": isAkra ? "t" : "f" };
        sessionStorage.setItem("Tesis", JSON.stringify(tesisData));
        Store.dispatch(setTesis(tesisData));
      } catch (error) {
        console.error("❌ App.js: Error setting Tesis data:", error);
      }

      // 🔥 CompanyId > 2 için SCADA Homepage'e yönlendir
      const companyIdNum = parseInt(companyIdFromUrl);
      if (companyIdNum > 2) {
        console.log("🏠 App.js: CompanyId > 2, redirecting to SCADA Homepage...", companyIdNum);
        axiosInstance.get(`/scada/pages/homepage/${companyIdNum}`)
          .then(res => {
            if (res.data && res.data.pageId) {
              console.log("🏠 SCADA Homepage found, redirecting to pageId:", res.data.pageId);
              // URL'i temizle ve SCADA sayfasına yönlendir
              window.history.replaceState({}, document.title, `/axisPreview/${res.data.pageId}`);
              window.location.href = `/axisPreview/${res.data.pageId}`;
            }
          })
          .catch(err => {
            console.log("⚠️ Could not fetch SCADA homepage:", err);
          });
        return; // Diğer işlemleri durdur
      }
    }

    // 🔥 URL'de auth parametreleri varsa (user_id, username vs.), URL'i temizle
    if (urlParams.has('user_id') || urlParams.has('companyId')) {
      window.history.replaceState({}, document.title, "/");
    }

    // 🔥 Check sessionStorage for Tesis
    let tesis_ = sessionStorage.getItem("Tesis");
    if (tesis_ !== null) {
      Store.dispatch(setTesis(JSON.parse(tesis_)));
    }

    componentDidMount();

    // 🔥 Check sessionStorage for ucer_id
    ucer_id_ = sessionStorage.getItem("ucer_id");
    if (ucer_id_) {
      ucer_id_ = Number(JSON.parse(ucer_id_));
      Store.dispatch(set_ucer_id(ucer_id_))
    }

    // if(window.location.pathname==="/dynamicPage"){
    // document.querySelector(".aside-left-bar").style.minHeight=String(document.querySelector(".main_sec").getBoundingClientRect().height+document.querySelector("header").getBoundingClientRect().height-24)+"px";

    // }

    if (
      window.location.pathname === "/raporlama" ||
      window.location.pathname === "/profile" ||
      window.location.pathname === "/dynamicPage" ||
      window.location.pathname === "/addWidgetToLibrary"
    ) {
      document.querySelector("body").style.overflow = "hidden auto";
    } else {
      if (/^\/pages\/[^\/]+$/.test(window.location.pathname)) {
        document.querySelector("body").style.overflow = "hidden auto";
      } else {
        if (/^\/pages\/[^\/]+(\/edit)?$/.test(window.location.pathname)) {
          document.querySelector("body").style.overflow = "hidden auto";
        } else if (
          /^\/template_management\/[^\/]+(\/edit)?$/.test(
            window.location.pathname
          )
        ) {
          document.querySelector("body").style.overflow = "hidden auto";
        } else {
          document.querySelector("body").style.overflow = "hidden";
        }
      }
    }
  }, [window.location.pathname]);

  useEffect(() => {
    try {
      const sx = document.querySelector(".aside-left-bar");
      if (sx) {
        sx.style.zoom = "100%";
      }
    } catch (err) {
    }

    const componentDidMount = async () => {
      // 🔥 FIRST: Re-initialize temp_com_id from sessionStorage
      temp_com_id = sessionStorage.getItem("TEMPCOM") || temp_com_id;


      // connectDB((err)=>{
      //   if(!err){
      //     mongodb=getDB()
      //   }
      // })

      // 🔥 Check URL for companyId parameter (from TesisSec new tab)
      const urlParams = new URLSearchParams(window.location.search);
      const companyIdFromUrl = urlParams.get('companyId');
      if (companyIdFromUrl) {

        // Set sessionStorage
        sessionStorage.setItem("TEMPCOM", companyIdFromUrl);
        sessionStorage.setItem("ucer_id", companyIdFromUrl);
        const isAkra = (companyIdFromUrl === "1" || companyIdFromUrl === "2");
        const tesisData = { "Akra": isAkra ? "t" : "f" };
        sessionStorage.setItem("Tesis", JSON.stringify(tesisData));

        // Dispatch to Redux immediately
        await Store.dispatch(SET_COMPANY_ID(companyIdFromUrl));
        await Store.dispatch(set_temp_com_id(companyIdFromUrl));  // ✅ LeftPart için temp_com_id'yi de set et!
        await Store.dispatch(setTesis(tesisData));
        com_id_ = companyIdFromUrl;
        temp_com_id = companyIdFromUrl;  // ✅ API çağrıları için temp_com_id variable'ını da güncelle!
      }

      // 🔥 Check sessionStorage for TEMPCOM
      let com_id = sessionStorage.getItem("TEMPCOM");
      if (com_id) {
        await Store.dispatch(SET_COMPANY_ID(com_id));
        await Store.dispatch(set_temp_com_id(com_id));  // ✅ LeftPart için temp_com_id'yi de set et!
        com_id_ = com_id;
      }

      let pp = localStorage.getItem("profile_photo");
      if (pp) {
        await Store.dispatch(setProfilePhoto(pp));
      }

      // 🔥 Check sessionStorage for Tesis
      let tesis_ = sessionStorage.getItem("Tesis");
      if (tesis_ !== null) {
        await Store.dispatch(setTesis(JSON.parse(tesis_)));
      }

      let profile_infos = localStorage.getItem("profile_info");
      if (profile_infos) {
        await Store.dispatch(set_profile_infos(JSON.parse(profile_infos)));
      }

      let lsuser_id = sessionStorage.getItem("user_id");
      if (lsuser_id && lsuser_id !== "") {
        await Store.dispatch(set_uid(lsuser_id));
      }
      let lsuser_email = sessionStorage.getItem("user_email");
      if (lsuser_email && lsuser_email !== "") {
        await Store.dispatch(set_email(lsuser_email));
      }
      let lsusername = sessionStorage.getItem("username");
      if (lsusername && lsusername !== "") {
        await Store.dispatch(set_username(lsusername));
      }

      // 🔥 Authentication check - redirect to login if no user_id
      const publicPaths = ["/login", "/TesisSec", "/forget_password"];
      const currentPath = window.location.pathname;
      // 🔥 sessionStorage'dan direkt oku çünkü localStorage bridge useEffect'te set etti
      const currentUserId = sessionStorage.getItem("user_id");
      if (!currentUserId && !publicPaths.includes(currentPath)) {
        history.push("/login");
        return;
      }

      // 🔥 Skip API calls when on TesisSec page (user hasn't selected facility yet)
      if (currentUserId && com_id !== "" && window.location.pathname !== "/TesisSec") {
        let tag_ids__ = [];

        try {
          const _request_ = await axiosInstance.get("/pages/GetDashboard");
          const response__ = _request_.data;

          var newd = response__.sort((a, b) => a.tip.localeCompare(b.tip));



          await Store.dispatch(
            set_dashboard_data(
              response__.sort((a, b) =>
                Number(a.tagId) > Number(b.tagId) ? 1 : -1
              )
            )
          );

        } catch (err) {
        }

        try {
          const req__ = await axiosInstance.post("/person/GetUserList", {
            companyId: String(temp_com_id),
          });
          const response__ = req__.data;

          if (req__.status === 200 && response__.length > 0) {
            let data_ = response__;
            data_.forEach(async (a) => {
              let newObj;
              let userid = a.userId;
              let yetkilendirme = a.yetkilendirme;
              if (
                yetkilendirme !== null &&
                yetkilendirme !== "" &&
                a.userId === lsuser_id
              ) {
                yetkilendirme = JSON.parse(yetkilendirme);

                newObj = { [userid]: yetkilendirme[Number(temp_com_id)] }; // Use actual companyId
                await Store.dispatch(set_yetkilendirme_state(newObj));
              }
            });
          }

          if (req__.status === 200 && response__.length > 0) {
            Store.dispatch(set_user_item(response__));
          }
        } catch (err) {
          // Error handled silently
        }

        try {
          const req__ = await axiosInstance.post("/tags/GetAllReactFlows", {
            companyId: String(temp_com_id),
          });
          const response__ = req__.data;

          if (req__.status === 200) {
            Store.dispatch(set_reactflowList(response__));
          }
        } catch (err) {
          // Error handled silently
        }

        try {
          const req__ = await axiosInstance.get("/pages/GetWidgetsList");
          const response__ = req__.data;

          if (req__.status === 200) {
            Store.dispatch(set_widget_library(response__));
          }
        } catch (err) {
          // Error handled silently
        }

        try {
          const finalCompanyId = sessionStorage.getItem("TEMPCOM") || temp_com_id;

          // Only call API if we have a valid company ID
          if (finalCompanyId) {
            const req_ = await axiosInstance.post("/tags/GetTagsForTrend", { companyId: String(finalCompanyId) });
            const response = req_.data;

            if (req_.status === 200) {
              await Store.dispatch(set_tags_for_trend_page(response));
            }
          }
        } catch (err) {
          // GetTagsForTrend error - silently fail
        }

        try {
          const response = await axiosInstance.post("/pages/GetPageList", {
            userId: user_id,
            companyId: String(temp_com_id),
          });
          const data = response.data;
          var newlist = data;
          newlist.forEach(async (i) => {
            await Store.dispatch(add_page_name(i.pageName));
            if (i.details !== "") {
              i.details = JSON.parse(i.details);
            }
          });
          await Store.dispatch(set_fetch_pages_control(true));
          await Store.dispatch(set_pages(newlist));
        } catch (err) {
          // GetPageList error
        }



        // Önceki interval varsa temizle (sonsuz döngüyü önlemek için)
        if (alarmIntervalRef.current) {
          clearInterval(alarmIntervalRef.current);
        }

        alarmIntervalRef.current = setInterval(async () => {
          try {
            const request = await axiosInstance.post("/tags/GetAlarmList", {
              companyId: String(temp_com_id),
            });
            const response = request.data;

            if (request.status === 200) {
              if (props.alarms.length === 0 || props.alarms2.length === 0) {
                Store.dispatch(set_alarms_action(response));
                Store.dispatch(set_alarms_action2(response));
              } else {
                let newData = props.alarms2;
                newData = newData.sort(
                  (a, b) =>
                    new Date(b.date).getTime() - new Date(a.date).getTime()
                );
                newData = newData.filter((i) => {
                  return i.confirm_ === 0;
                });
                let newData2 = response;
                newData2 = newData2.sort(
                  (a, b) =>
                    new Date(b.date).getTime() - new Date(a.date).getTime()
                );
                newData2 = newData2.filter((i) => {
                  return i.confirm_ === 0;
                });
                if (
                  JSON.stringify(newData2[newData2.length - 1]) !==
                  JSON.stringify(newData[newData.length - 1])
                ) {
                  Store.dispatch(set_alarms_action2(response));
                }
              }
            }
          } catch (err) {
          }
        }, 5000);

        try {
          const req_12 = await axiosInstance.post("/tags/GetVarsList", { companyId: String(temp_com_id) });
          const response2 = req_12.data;
          let newData = [];
          let newDataValue = [];

          if (req_12.status === 200 && response2.length > 0) {
            function transformObject(obj) {
              let newObj = {};

              for (let key in obj) {
                if (key.startsWith("var")) {
                  let newKey = key.replace("var", "tag");
                  newObj[newKey] = obj[key];
                } else {
                  newObj[key] = obj[key];
                }
              }

              // Ekstra tip ekleme
              newObj["tip"] = "Var";

              return newObj;
            }
            response2.forEach((item, index) => {
              let newObj = transformObject(item);
              newData.push(newObj);
            })


          }


          // Use GetTaglist directly (GetTags endpoint doesn't exist)
          let response12, data;
          response12 = await axiosInstance.post("/tags/GetTaglist", {
            companyId: Number(temp_com_id),
          });
          data = response12.data;
          var sort_strings = [];
          data.forEach((i) => {
            sort_strings.push(i.tagName);
          });
          sort_strings.sort();
          ;

          let new_sorted_array = [];
          sort_strings.forEach((k) => {
            for (let j = 0; j < data.length; j++) {
              if (data[j].tagName === k) {
                new_sorted_array.push(data[j]);
                continue;
              }
            }
          });
          const uniqueById_widget = new_sorted_array.reduce((unique, item) => {
            // Her öğeyi klonlayarak yeni bir nesne oluşturun
            const newItem = { ...item };

            // Şartlara göre tagName ve tagName2 değerlerini değiştirin
            if (
              newItem.tagName2 &&
              newItem.tagName2 !== null &&
              newItem.tagName2 !== ""
            ) {
              let old_name = newItem.tagName;
              newItem.tagName = newItem.tagName2;
              newItem.tagName2 = old_name;
            }

            // Eşsiz öğeleri tagId'ye göre kontrol edip ekleyin
            if (!unique.some((obj) => obj.tagId === newItem.tagId)) {
              unique.push(newItem);
            }

            return unique;
          }, []);

          let uniqueById_widget2 = []

            ;
          if (data) {
            uniqueById_widget2 = [...uniqueById_widget, ...newData]

            // Eğer GetTags/GetTaglist sıfır döndüyse, trend taglarını da ekle (non-Var kurtarma)
            if (uniqueById_widget.length === 0) {
              try {
                const fallbackCompanyId = sessionStorage.getItem("TEMPCOM") || temp_com_id;

                // Only call API if we have a valid company ID
                if (!fallbackCompanyId) {
                  throw new Error("Invalid company ID for fallback");
                }

                const trendReq = await axiosInstance.post("/tags/GetTagsForTrend", { companyId: String(fallbackCompanyId) });
                const trendRes = trendReq.data;
                if (Array.isArray(trendRes) && trendRes.length > 0) {
                  const merged = [...trendRes, ...uniqueById_widget2]
                  const uniq = []
                  const seen = new Set()
                  for (const t of merged) {
                    const id = String(t?.tagId)
                    if (!seen.has(id)) { seen.add(id); uniq.push(t) }
                  }
                  uniqueById_widget2 = uniq
                }
              } catch (e) {
                // Fallback merge error handled silently
              }
            }

            Store.dispatch(set_tag_list(uniqueById_widget2));
            let i = 0;
            let newdata_ = [];
            while (i < data.length) {
              newdata_.push({ tagId: data[i].tagId });
              i++;
            }
            await Store.dispatch(set_tag_ids(newdata_));
            tag_ids__ = newdata_;
          }




          const req_2 = await axiosInstance.post("/tags/GetVarValues", response2);
          const response3 = req_2.data;


          function transformObject(obj) {
            let newObj = {};

            for (let key in obj) {
              if (key.startsWith("var")) {
                let newKey = key.replace("var", "tag");
                newObj[newKey] = obj[key];
              } else if (key.startsWith("value")) {
                let newKey = key.replace("value", "tagValue");
                newObj[newKey] = obj[key];
              } else {
                newObj[key] = obj[key];
              }
            }

            // Ekstra tip ekleme
            newObj["tip"] = "Var";

            return newObj;
          }
          response3.forEach((item, index) => {
            let newObj = transformObject(item);
            newDataValue.push(newObj);
          })

          try {
            const req_ = await axiosInstance.post("/tags/GetTagValues", tag_ids__);
            const response = req_.data;

            let tagId8729 = null;

            if (req_.status === 200) {
              const roundedResponse = response.map((item) => {
                if (item.tagId === "8729") {
                  tagId8729 = Number(item.tagValue);
                }
                // props.tag_list'ten item.tagId ile eşleşen elemanı bul
                const matchingTag = props.tag_list.find(
                  (tag) => tag.tagId === item.tagId
                );

                // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                const decimalPlaces =
                  matchingTag && matchingTag.tagDecimal !== null
                    ? Number(matchingTag.tagDecimal)
                    : 2;



                return {
                  ...item,
                  tagValue: parseFloat(item.tagValue).toFixed(decimalPlaces),
                };
              });

              // response3 varsa ve boş değilse, roundedResponse'un sonuna ekle
              if (newDataValue && newDataValue.length > 0) {
                roundedResponse.push(...newDataValue);
              }

              await Store.dispatch(set_tag_values(roundedResponse));

              const processState = (state, targetArray, hasDevice = false) => {
                state.forEach(item => {
                  Object.values(item).forEach(subItems => {
                    subItems.forEach(({ tagId, text, device, type }) => {
                      if (!type || type !== "Var") {
                        const entry = { tagId, text };
                        if (hasDevice && device) entry.device = device;
                        targetArray.push(entry);
                      }
                    });
                  });
                });
              };

              const obj2__ = [], obj4__ = [], obj6__ = [], obj8__ = [], obj10__ = [], obj12__ = [], obj14__ = [], obj16__ = [], obj18__ = [], obj20__ = [], obj22__ = [], obj24__ = [], obj26__ = [], obj28__ = [], obj30__ = [], obj32__ = [], obj34__ = [];

              processState(state_1, obj2__);
              processState(state_2, obj4__);
              processState(state_3, obj6__);
              processState(state_4, obj8__);
              processState(vrf_state, obj10__, true);
              processState(pumps_state, obj12__);
              processState(booster_state, obj14__);
              processState(fans_state, obj16__);
              processState(vrf5_state, obj18__, true);
              processState(vrf4_state, obj20__, true);
              processState(vrf3_state, obj22__, true);
              processState(vrf2_state, obj24__, true);
              processState(su_depolari_state, obj26__);
              processState(hidrofor_state, obj28__);
              processState(vrf_teras, obj30__, true);
              processState(vrfks_state, obj32__, true);
              processState(vrfhacim_state, obj34__, true);



              var newdata = [];
              var newdata2 = [];
              var newdata3 = [];
              var newdata4 = [];
              var newdata5 = [];
              var newdata6 = [];
              var newdata7 = [];
              var newdata8 = [];
              var newdata9 = [];
              var newdata10 = [];
              var newdata11 = [];
              var newdata12 = [];
              var newdata13 = [];
              var newdata14 = [];
              var newdata15 = [];
              var newdata16 = [];
              var newdata17 = [];

              obj2__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              obj4__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata2.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              obj6__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata3.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              obj8__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata4.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              obj10__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    if (item2.device) {
                      newdata5.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                        device: item2.device
                      });
                    } else {
                      newdata5.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                      });
                    }

                  }
                });
              });

              obj12__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata6.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              let cop = 0;
              let cop_control = [];
              obj14__.forEach((item2) => {
                response.forEach((item) => {
                  if (
                    item.tagId === "134" ||
                    item.tagId === "135" ||
                    item.tagId === "136" ||
                    item.tagId === "137" ||
                    item.tagId === "138"
                  ) {
                    if (cop_control.indexOf(item.tagId) < 0) {
                      cop += Number(item.tagValue);
                      ;
                      cop_control.push(item.tagId);
                    }
                  }

                  if (tagId8729 !== null) cop += tagId8729;

                  if (item.tagId === item2.tagId) {
                    newdata7.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });
              Store.dispatch(set_cop(cop));
              obj16__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata8.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });
              obj18__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    if (item2.device) {
                      newdata9.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                        device: item2.device
                      });
                    } else {
                      newdata9.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                      });
                    }
                  }
                });
              });

              obj32__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata16.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              obj34__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata17.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              obj20__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    if (item2.device) {
                      newdata10.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                        device: item2.device
                      });
                    } else {
                      newdata10.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                      });
                    }
                  }
                });
              });
              obj22__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    if (item2.device) {
                      newdata11.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                        device: item2.device
                      });
                    } else {
                      newdata11.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                      });
                    }
                  }
                });
              });
              obj24__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    if (item2.device) {
                      newdata12.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                        device: item2.device
                      });
                    } else {
                      newdata12.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                      });
                    }
                  }
                });
              });
              obj26__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata13.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              obj28__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    newdata14.push({
                      tagId: item.tagId,
                      tagValue: item.tagValue,
                    });
                  }
                });
              });

              obj30__.forEach((item2) => {
                response.forEach((item) => {
                  if (item.tagId === item2.tagId) {
                    if (item2.device) {
                      newdata15.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                        device: item2.device
                      });
                    } else {
                      newdata15.push({
                        tagId: item.tagId,
                        tagValue: item.tagValue,
                      });
                    }
                  }
                });
              });
              ;

              Store.dispatch(set_energy_tags(newdata));
              Store.dispatch(set_energy_tags2(newdata2));
              Store.dispatch(set_energy_tags3(newdata3));
              Store.dispatch(set_sıcak_su_sistemi(newdata4));
              Store.dispatch(set_vrf_tags(newdata5));
              Store.dispatch(set_pumps_tags(newdata6));
              Store.dispatch(set_booster_tags(newdata7));
              Store.dispatch(set_fans_tags(newdata8));
              Store.dispatch(set_vrfks_tags(newdata16));
              Store.dispatch(set_vrfhacim_tags(newdata17));

              Store.dispatch(set_vrf5_tags(newdata9));
              Store.dispatch(set_vrf4_tags(newdata10));
              Store.dispatch(set_vrf3_tags(newdata11));
              Store.dispatch(set_vrf2_tags(newdata12));
              Store.dispatch(set_water_storage(newdata13));
              Store.dispatch(set_hidrofor(newdata14));
              Store.dispatch(set_vrf_teras_tags(newdata15));
            }
          } catch (err) {
          }


          

        } catch (err) {
          console.error(err);
        }

        try {
          const response = await axiosInstance.post("/tags/GetTagsForTotalizer", { companyId: Number(temp_com_id) });
          const data = response.data;

          // tagId değerine göre unique (benzersiz) hale getirme
          const uniqueTags = Array.from(
            new Map(data.map((item) => [item.tagId, item])).values()
          );

          Store.dispatch(setTotalizerTags(uniqueTags));
        } catch (err) {
          // GetTotalizerTags error
        }


        try {
          const response = await axiosInstance.post("/tags/GetMisafirOda", {
            companyId: String(temp_com_id)
          });
          const data = response.data;

          Store.dispatch(set_misafir_oda(data[0]));
        } catch (err) {
          // GetMisafirOda error
        }

        try {
          const _request_ = await axiosInstance.get("/tags/GetCompanies");
          const response__ = _request_.data;

          if (_request_.status === 200) {
            await Store.dispatch(setCompaniesList(response__));

            // Company logo URL'ini bul ve set et
            const currentCompany = response__.find(c =>
              String(c.companyID) === String(temp_com_id) ||
              String(c.CompanyID) === String(temp_com_id)
            );
            if (currentCompany && currentCompany.logoUrl) {
              await Store.dispatch(set_company_logo_url(currentCompany.logoUrl));
            } else if (currentCompany && currentCompany.LogoUrl) {
              await Store.dispatch(set_company_logo_url(currentCompany.LogoUrl));
            }
          }
        } catch (err) {
          // GetCompanies error
        }
        try {
          const request = await axiosInstance.post("/tags/GetNotificationList", {
            companyId: com_id_,
          });
          const response = request.data;

          Store.dispatch(set_notis_action(response));
        } catch (err) {
          // GetNotificationList error
        }

      }

      // try {
      //   const request = await fetch(
      //     "https://app-rmmsapi.azurewebsites.net/api/tags/GetScenario/",
      //     {
      //       method: "POST",
      //       headers: {
      //         "Content-Type": "application/json",
      //         Accept: "application/json",
      //       },
      //       body: JSON.stringify({
      //         Id: 16,
      //       }),
      //     }
      //   );
      //   const response = await request.json();
      // } catch (err) {
      // }



      var com_id__ = String(com_id_);

      if (com_id__.length < 2 && com_id__.length > 0) {
        let string__ = "";
        var i = 0;
        while (i < 8) {
          var kaver = Math.floor(Math.random() * 2);
          if (kaver === 1) {
            var harf = Math.floor(Math.random() * alfb.length);
            string__ += alfb[harf];
          } else {
            var say_ = Math.floor(Math.random() * say.length);
            string__ += say[say_];
          }
          i++;
        }

        i = 0;
        var j = 0;
        for (j = 0; j < com_id__.length; j++) {
          var num_ = Number(com_id__[j]);
          string__ += alfb[num_];
        }
        while (i < 8) {
          var kaver = Math.floor(Math.random() * 2);
          if (kaver === 1) {
            var harf = Math.floor(Math.random() * alfb.length);
            string__ += alfb[harf];
          } else {
            var say_ = Math.floor(Math.random() * say.length);
            string__ += say[say_];
          }
          i++;
        }

        var k = com_id__.length;
        string__ += alfb[k * 2];

      }

      // try {
      //   await databasefirebase.ref(`${props.auth_reducer}/Pages`).once("value").then(async res => {

      //     if (typeof (res.val()) === "object") {
      //       Object.values(res.val()).forEach(val => {
      //         list.push(val)
      //       })
      //     } else {
      //       res.forEach(i => {
      //         list.push(i.val())
      //       })
      //     }

      //     await Store.dispatch(set_pages(list))

      //   })

      //   await databasefirebase.ref(`${props.auth_reducer}/Pages_Names`).once("value").then(res => {
      //     res.forEach(i => {
      //       Store.dispatch(add_page_name(i.val()))

      //     })
      //   })
      // } catch (err) {
      // }
    };

    componentDidMount();
  }, [props.pages]);

  // useEffect(() => {
  //   if (path === "/notifications") {
  //     document.querySelector(".r104f42s7-0-0-beta-28").style.gridTemplateColumns = "62px 350px 130px 150px 125px 140px"
  //   }
  // }, [path])
  const [control_tesis, Set_control_tesis] = useState(0);
  useEffect(() => {
    var toplam = 0;
    Object.entries(props.tesis).forEach((a) => {
      if (a[1] !== "") {
        toplam++;
        Set_control_tesis(control_tesis + 1);
      }
    });

  }, [props.tesis]);

  useEffect(() => {
    // .main_alt_pages altında ilk .show_external_trend sınıfına sahip elemanı bulun ve silin
    const mainAltPages = document.querySelector(".main_alt_pages");
    if (mainAltPages) {
      const showExternalTrends = mainAltPages.querySelectorAll(
        ".show_external_trend"
      );
      if (showExternalTrends.length > 0) {
        showExternalTrends[0].remove();
      }
    }
  }, [window.location.href]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div>
        <BrowserRouter>
        {props.company_id !== "" ? (
          <>
            <main className="real-main-svrewggd5468">
              <Route exact path={"/"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  {props.tesis["Akra"] === "t" ? (
                    <Dashboard />
                  ) : (
                    <CrownHomePage />
                  )}
                </div>
              </Route>
              <Route exact path={"/user_management"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <User_Management />
                </div>
              </Route>
              <Route path={"/VRF"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Dashboard_vrf />
                </div>
              </Route>

              <Route path={"/misafir_oda"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Misafir_Oda />
                </div>
              </Route>
              <Route path={"/hot_water_system"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Dash_Sicak_Su />
                </div>
              </Route>
              {/* <Route path={"/ENERGY"}>
              <LeftPart pathname={path} />
              <div className="main_alt_pages">
                <Header pathname={path} />
                <Dashboard_energy />
              </div>
            </Route> */}
              <Route path={"/electric_generator"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Electric_generator />
                </div>
              </Route>
              <Route exact path={"/raporlama"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Raporlama />
                </div>
              </Route>
              <Route path={"/raporlama/:id"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Raporlama />
                </div>
              </Route>

              <Route path={"/Alarmpanel"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Alarm />
                </div>
              </Route>
              <Route exact path={"/addWidgetToLibrary"}>
                <LeftPart />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <AddW_To_Library />
                </div>
              </Route>
              <Route path={"/profile/edit"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Editprofile_ />
                </div>
              </Route>
              <Route path={"/communication/plc"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <PLC />
                </div>
              </Route>
              <Route path={"/communication/channel"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Channel />
                </div>
              </Route>
              <Route exact path={"/communication/tag"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Point />
                </div>
              </Route>
              <Route exact path={"/flow"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <DnDFlow />
                </div>
              </Route>
              <Route exact path={"/flow/:name"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <DnDFlow />
                </div>
              </Route>

              <Route exact path={"/tasks"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <WorkflowDashboard />
                </div>
              </Route>

              {/* Trend Raporları rotası kaldırıldı */}

              <Route exact path={"/code-editor"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <CodeEditor />
                </div>
              </Route>

              <Route exact path={"/templates"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <TemplateManager />
                </div>
              </Route>

              <Route exact path={"/services"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <ServiceManagement />
                </div>
              </Route>

              <Route exact path={"/datasources"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <DataSourcesLayout />
                </div>
              </Route>

              <Route exact path={"/profile"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Profile />
                </div>
              </Route>

              <Route exact path={"/pages_management"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Page_Managment names={list} />
                </div>
              </Route>
              <Route path={"/pages_management/program/:id"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Programflow />
                </div>
              </Route>

              <Switch>
                <Route exact path="/pages/:name">
                  <LeftPart pathname={path} />
                  <div className="main_alt_pages">
                    <Header pathname={path} />
                    <DynRead pathname={path} _pages={list} />
                  </div>
                </Route>
                <Route exact path="/pages/:name/edit">
                  <LeftPart pathname={path} />
                  <div className="main_alt_pages">
                    <Header pathname={path} />
                    <DynEdit _pages={list} />
                  </div>
                </Route>
              </Switch>

              {/* ✨ AxisScada Routes */}
              <Route exact path={"/axisPageDesigner"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <PageDesignerRGL />
                </div>
              </Route>
              <Route exact path={"/axisPages"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <PageManagement />
                </div>
              </Route>
              <Route exact path={"/axisWidgets"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <WidgetManagement />
                </div>
              </Route>
              <Route exact path={"/axisWidgetDesigner"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <WidgetDesigner />
                </div>
              </Route>
              <Route path={"/axisWidgetDesigner/:widgetId"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <WidgetDesigner />
                </div>
              </Route>
              <Route path={"/axisPreview/:id"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <PreviewMode />
                </div>
              </Route>

              {/* İŞ EMİRLERİ Routes */}
              <Route exact path={"/workorders"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <WorkOrders />
                </div>
              </Route>
              <Route exact path={"/templateworkorders"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <TemplateWorkOrders />
                </div>
              </Route>

              {/* ✨ New SCADARouter for /scada/* paths */}
              <Route path={"/scada"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <SCADARouter />
                </div>
              </Route>

              <Route path={"/dashboard/:name/edit"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header3 pathname={path} />
                  <All2Edit pathname={path} _pages={list} />
                </div>
              </Route>
              <Route exact path={"/energy"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Energy />
                </div>
              </Route>
              <Route exact path={"/energy2"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Energy2 />
                </div>
              </Route>
              <Route exact path={"/energy3"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Energy3 />
                </div>
              </Route>
              <Route exact path={"/boiler"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <HotWaterBoiler />
                </div>
              </Route>
              <Route exact path={"/booster"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Booster />
                </div>
              </Route>
              <Route exact path={"/fans"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Fans />
                </div>
              </Route>
              <Route exact path={"/vrf1"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <VRF1 />
                </div>
              </Route>
              <Route exact path={"/vrf2"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <VRF2 />
                </div>
              </Route>
              <Route exact path={"/vrf3"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <VRF3 />
                </div>
              </Route>

              <Route exact path={"/pumps"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Pumps />
                </div>
              </Route>

              <Route exact path={"/deleteLogs"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <DeleteLogs />
                </div>
              </Route>

              <Route exact path={"/vrf4"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <VRF4 />
                </div>
              </Route>
              <Route exact path={"/vrf5"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <VRF5 />
                </div>
              </Route>
              <Route exact path={"/vrfks"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <VRFKS />
                </div>
              </Route>
              <Route exact path={"/vrfhacim"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <VRFHacim />
                </div>
              </Route>
              <Route exact path={"/vrfteras"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <VRFTeras />
                </div>
              </Route>
              <Route exact path={"/su_depolari"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Su_Depoları />
                </div>
              </Route>

              <Route exact path={"/dashboard"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Main_Dash />
                </div>
              </Route>

              <Route exact path={"/template_management"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Template_Widget_Management />
                </div>
              </Route>
              <Route exact path={"/template_management/:name/edit"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Template_Widget_Edit />
                </div>
              </Route>

              <Route exact path={"/pumps_system"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Dash_Pumps />
                </div>
              </Route>
              <Route exact path={"/hidrofor"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Hidrofor />
                </div>
              </Route>

              {/*  --------------- CROWN ------------------- */}

              <Route exact path={"/crowndashboard"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <CDashboard />
                </div>
              </Route>
              <Route exact path={"/kazan-dairesi-home"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <KazanDairesiHome />
                </div>
              </Route>

              <Route exact path={"/kazan-sistemi"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <CKazanSistemi />
                </div>
              </Route>
              <Route exact path={"/denemePages"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <DenemeHomePage />
                </div>
              </Route>
              <Route exact path={"/kazan1"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Kazan1 />
                </div>
              </Route>

              <Route exact path={"/kazan2"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Kazan2 />
                </div>
              </Route>
              <Route exact path={"/kazan3"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Kazan3 />
                </div>
              </Route>

              <Route exact path={"/sicak-su-sistemi"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <CSicakSuSistemi />
                </div>
              </Route>
              <Route exact path={"/pompa-hidrofor"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <CPompaVeHidrofor />
                </div>
              </Route>
              <Route exact path={"/pompalar1"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Pompalar1 />
                </div>
              </Route>
              <Route exact path={"/pompalar2"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Pompalar2 />
                </div>
              </Route>
              <Route exact path={"/pompalar3"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Pompalar3 />
                </div>
              </Route>
              <Route exact path={"/fanlar"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <CFanlar />
                </div>
              </Route>
              <Route exact path={"/egzost-fan"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <EgzostFan />
                </div>
              </Route>

              <Route exact path={"/jenerator-home"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <CJeneratorHome />
                </div>
              </Route>
              <Route exact path={"/crown-su-depolari"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <CSuDepoları />
                </div>
              </Route>

              <Route exact path={"/misaifr_oda_izleme"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Misafir_oda_izleme />
                </div>
              </Route>

              <Route exact path={"/role_management"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <Role_Management />
                </div>
              </Route>

              <Route exact path={"/ConnectionStatus"}>
                <LeftPart pathname={path} />
                <div className="main_alt_pages">
                  <Header pathname={path} />
                  <ConnectionStatus />
                </div>
              </Route>
            </main>
            {/* <div style={{ borderTop: "6px solid rgb(34,34,34)" }} className='flow_part'>
            <div>
              <App2 style={{ height: "100vh" }} />
            </div>
          </div> */}
          </>
        ) : (
          <React.Fragment>
            <div>
              <Route exact path={"/"}>
                <div className="login-part-kapsayici-div">
                  <Login />
                </div>
              </Route>
              <Route exact path={"/TesisSec"}>
                <TesisSec />
              </Route>
              <Route exact path={"/forget_password"}>
                <div className="login-part-kapsayici-div">
                  <Forgot_PWD />
                </div>
              </Route>
              <Route exact path={"/signup"}>
                <div className="login-part-kapsayici-div">
                  <SignUpPage />
                </div>
              </Route>
            </div>
          </React.Fragment>
        )}
        <TagInfoModalManager />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
};
const MapStateToProps = (state) => {
  return {
    pages_: state.project_reducer.pages,
    auth_reducer: state.auth_reducer.user_id,
    profile: state.project_reducer.profile_infos,
    company_id: state.project_reducer.company_id,
    main_path: state.project_reducer.main_path,
    dash_datas: state.project_reducer.dashboard_datas,
    tag_ids: state.project_reducer.tag_ids,
    tesis: state.project_reducer.tesis,
    tag_list: state.project_reducer.tag_list,
    alarms: state.project_reducer.alarms,
    alarms2: state.project_reducer.alarms2,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    users_list: state.project_reducer.users_list,


  };
};
export default connect(MapStateToProps)(App);
